import * as x from "react";
import Pt, { Fragment as kn, createContext as Wo, useContext as zo, useRef as he, useEffect as Ve, useCallback as we, useState as be, Children as jn, useLayoutEffect as Bn, forwardRef as Vo, cloneElement as Wn, createElement as Ho } from "react";
import { j as O, u as zn, O as Go, P as Yo, h as q, i as z, l as K, B as H, p as ot, m as J, n as Ae, r as ee, Q as Xo, R as $t, G as Ko, J as Uo, w as oe, s as ve, U as Vn, t as Hn, v as qo } from "./UnstyledButton-ujNMaBde.js";
import { c as Ze, u as Gn, r as Jo, g as Yn, b as Qo, a as Mt, O as Xn, L as Kn, C as Zo } from "./CloseButton-Bp_UJ8Gq.js";
import { u as Un, c as er } from "./DirectionProvider-DtCDJ2BX.js";
import * as tr from "react-dom";
import nr from "react-dom";
function or(e) {
  return Array.isArray(e) || e === null ? !1 : typeof e == "object" ? e.type !== kn : !1;
}
function qn(e = null) {
  const t = Wo(e);
  return [({ children: r, value: s }) => /* @__PURE__ */ O.jsx(t.Provider, { value: s, children: r }), () => zo(t)];
}
const rr = () => {
};
function sr(e, t = { active: !0 }) {
  return typeof e != "function" || !t.active ? t.onKeyDown || rr : (n) => {
    n.key === "Escape" && (e(n), t.onTrigger?.());
  };
}
const ir = ["mousedown", "touchstart"];
function cr(e, t, n) {
  const o = he(null), r = t || ir;
  return Ve(() => {
    const s = (i) => {
      const { target: c } = i ?? {};
      if (Array.isArray(n)) {
        const a = !document.body.contains(c) && c?.tagName !== "HTML";
        n.every((f) => !!f && !i.composedPath().includes(f)) && !a && e(i);
      } else o.current && !o.current.contains(c) && e(i);
    };
    return r.forEach((i) => document.addEventListener(i, s)), () => {
      r.forEach((i) => document.removeEventListener(i, s));
    };
  }, [o, e, n]), o;
}
function ar({
  opened: e,
  shouldReturnFocus: t = !0
}) {
  const n = he(null), o = () => {
    n.current && "focus" in n.current && typeof n.current.focus == "function" && n.current?.focus({ preventScroll: !0 });
  };
  return Ze(() => {
    let r = -1;
    const s = (i) => {
      i.key === "Tab" && window.clearTimeout(r);
    };
    return document.addEventListener("keydown", s), e ? n.current = document.activeElement : t && (r = window.setTimeout(o, 10)), () => {
      window.clearTimeout(r), document.removeEventListener("keydown", s);
    };
  }, [e, t]), o;
}
const lr = /input|select|textarea|button|object/, Jn = "a, input, select, textarea, button, object, [tabindex]";
function ur(e) {
  return process.env.NODE_ENV === "test" ? !1 : e.style.display === "none";
}
function fr(e) {
  if (e.getAttribute("aria-hidden") || e.getAttribute("hidden") || e.getAttribute("type") === "hidden")
    return !1;
  let n = e;
  for (; n && !(n === document.body || n.nodeType === 11); ) {
    if (ur(n))
      return !1;
    n = n.parentNode;
  }
  return !0;
}
function Qn(e) {
  let t = e.getAttribute("tabindex");
  return t === null && (t = void 0), parseInt(t, 10);
}
function Tt(e) {
  const t = e.nodeName.toLowerCase(), n = !Number.isNaN(Qn(e));
  return /* @ts-expect-error function accepts any html element but if it is a button, it should not be disabled to trigger the condition */ (lr.test(t) && !e.disabled || e instanceof HTMLAnchorElement && e.href || n) && fr(e);
}
function Zn(e) {
  const t = Qn(e);
  return (Number.isNaN(t) || t >= 0) && Tt(e);
}
function dr(e) {
  return Array.from(e.querySelectorAll(Jn)).filter(Zn);
}
function pr(e, t) {
  const n = dr(e);
  if (!n.length) {
    t.preventDefault();
    return;
  }
  const o = n[t.shiftKey ? 0 : n.length - 1], r = e.getRootNode();
  let s = o === r.activeElement || e === r.activeElement;
  const i = r.activeElement;
  if (i.tagName === "INPUT" && i.getAttribute("type") === "radio" && (s = n.filter(
    (f) => f.getAttribute("type") === "radio" && f.getAttribute("name") === i.getAttribute("name")
  ).includes(o)), !s)
    return;
  t.preventDefault();
  const a = n[t.shiftKey ? n.length - 1 : 0];
  a && a.focus();
}
function mr(e = !0) {
  const t = he(null), n = (r) => {
    let s = r.querySelector("[data-autofocus]");
    if (!s) {
      const i = Array.from(r.querySelectorAll(Jn));
      s = i.find(Zn) || i.find(Tt) || null, !s && Tt(r) && (s = r);
    }
    s ? s.focus({ preventScroll: !0 }) : process.env.NODE_ENV === "development" && console.warn(
      "[@mantine/hooks/use-focus-trap] Failed to find focusable element within provided node",
      r
    );
  }, o = we(
    (r) => {
      e && r !== null && t.current !== r && (r ? (setTimeout(() => {
        r.getRootNode() ? n(r) : process.env.NODE_ENV === "development" && console.warn("[@mantine/hooks/use-focus-trap] Ref node is not part of the dom", r);
      }), t.current = r) : t.current = null);
    },
    [e]
  );
  return Ve(() => {
    if (!e)
      return;
    t.current && setTimeout(() => n(t.current));
    const r = (s) => {
      s.key === "Tab" && t.current && pr(t.current, s);
    };
    return document.addEventListener("keydown", r), () => document.removeEventListener("keydown", r);
  }, [e]), o;
}
const gr = Pt.useId || (() => {
});
function hr() {
  const e = gr();
  return e ? `mantine-${e.replace(/:/g, "")}` : "";
}
function eo(e) {
  const t = hr(), [n, o] = be(t);
  return Gn(() => {
    o(Jo());
  }, []), typeof e == "string" ? e : typeof window > "u" ? t : n;
}
function Ki(e, t, n) {
  Ve(() => (window.addEventListener(e, t, n), () => window.removeEventListener(e, t, n)), [e, t]);
}
function vr({
  value: e,
  defaultValue: t,
  finalValue: n,
  onChange: o = () => {
  }
}) {
  const [r, s] = be(
    t !== void 0 ? t : n
  ), i = (c, ...a) => {
    s(c), o?.(c, ...a);
  };
  return e !== void 0 ? [e, o, !0] : [r, i, !1];
}
function Ui(e = !1, t = {}) {
  const [n, o] = be(e), r = we(() => {
    o((c) => c || (t.onOpen?.(), !0));
  }, [t.onOpen]), s = we(() => {
    o((c) => c && (t.onClose?.(), !1));
  }, [t.onClose]), i = we(() => {
    n ? s() : r();
  }, [s, r, n]);
  return [n, { open: r, close: s, toggle: i }];
}
function yr(e) {
  const t = Pt.version;
  return typeof Pt.version != "string" || t.startsWith("18.") ? e?.ref : e?.props?.ref;
}
function to(e) {
  const t = jn.toArray(e);
  return t.length !== 1 || !or(t[0]) ? null : t[0];
}
function no({
  classNames: e,
  styles: t,
  props: n,
  stylesCtx: o
}) {
  const r = zn();
  return {
    resolvedClassNames: Yo({
      theme: r,
      classNames: e,
      props: n,
      stylesCtx: o || void 0
    }),
    resolvedStyles: Go({
      theme: r,
      styles: t,
      props: n,
      stylesCtx: o || void 0
    })
  };
}
function rt() {
  return typeof window < "u";
}
function oo(e) {
  return ro(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Le(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function wr(e) {
  var t;
  return (t = (ro(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function ro(e) {
  return rt() ? e instanceof Node || e instanceof Le(e).Node : !1;
}
function U(e) {
  return rt() ? e instanceof Element || e instanceof Le(e).Element : !1;
}
function Ft(e) {
  return rt() ? e instanceof HTMLElement || e instanceof Le(e).HTMLElement : !1;
}
function Ot(e) {
  return !rt() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Le(e).ShadowRoot;
}
function br() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const xr = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function yt(e) {
  return xr.has(oo(e));
}
function Rr(e) {
  return Le(e).getComputedStyle(e);
}
function Er(e) {
  if (oo(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Ot(e) && e.host || // Fallback.
    wr(e)
  );
  return Ot(t) ? t.host : t;
}
function Cr() {
  const e = navigator.userAgentData;
  return e != null && e.platform ? e.platform : navigator.platform;
}
function Sr() {
  const e = navigator.userAgentData;
  return e && Array.isArray(e.brands) ? e.brands.map((t) => {
    let {
      brand: n,
      version: o
    } = t;
    return n + "/" + o;
  }).join(" ") : navigator.userAgent;
}
function Pr() {
  return /apple/i.test(navigator.vendor);
}
function Tr() {
  return Cr().toLowerCase().startsWith("mac") && !navigator.maxTouchPoints;
}
function Or() {
  return Sr().includes("jsdom/");
}
const ln = "data-floating-ui-focusable", Ar = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function un(e) {
  let t = e.activeElement;
  for (; ((n = t) == null || (n = n.shadowRoot) == null ? void 0 : n.activeElement) != null; ) {
    var n;
    t = t.shadowRoot.activeElement;
  }
  return t;
}
function ze(e, t) {
  if (!e || !t)
    return !1;
  const n = t.getRootNode == null ? void 0 : t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && Ot(n)) {
    let o = t;
    for (; o; ) {
      if (e === o)
        return !0;
      o = o.parentNode || o.host;
    }
  }
  return !1;
}
function Ie(e) {
  return "composedPath" in e ? e.composedPath()[0] : e.target;
}
function wt(e, t) {
  if (t == null)
    return !1;
  if ("composedPath" in e)
    return e.composedPath().includes(t);
  const n = e;
  return n.target != null && t.contains(n.target);
}
function Ir(e) {
  return e.matches("html,body");
}
function Te(e) {
  return e?.ownerDocument || document;
}
function Dr(e) {
  return Ft(e) && e.matches(Ar);
}
function Nr(e) {
  if (!e || Or()) return !0;
  try {
    return e.matches(":focus-visible");
  } catch {
    return !0;
  }
}
function _r(e) {
  return e ? e.hasAttribute(ln) ? e : e.querySelector("[" + ln + "]") || e : null;
}
function qe(e, t, n) {
  return n === void 0 && (n = !0), e.filter((r) => {
    var s;
    return r.parentId === t && (!n || ((s = r.context) == null ? void 0 : s.open));
  }).flatMap((r) => [r, ...qe(e, r.id, n)]);
}
function Lr(e) {
  return "nativeEvent" in e;
}
function At(e, t) {
  const n = ["mouse", "pen"];
  return n.push("", void 0), n.includes(e);
}
var $r = typeof document < "u", Mr = function() {
}, fe = $r ? Bn : Mr;
const Fr = {
  ...x
};
function Xe(e) {
  const t = x.useRef(e);
  return fe(() => {
    t.current = e;
  }), t;
}
const kr = Fr.useInsertionEffect, jr = kr || ((e) => e());
function ue(e) {
  const t = x.useRef(() => {
    if (process.env.NODE_ENV !== "production")
      throw new Error("Cannot call an event handler while rendering.");
  });
  return jr(() => {
    t.current = e;
  }), x.useCallback(function() {
    for (var n = arguments.length, o = new Array(n), r = 0; r < n; r++)
      o[r] = arguments[r];
    return t.current == null ? void 0 : t.current(...o);
  }, []);
}
const Br = ["top", "right", "bottom", "left"], ie = Math.min, X = Math.max, et = Math.round, Ke = Math.floor, de = (e) => ({
  x: e,
  y: e
}), Wr = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function It(e, t, n) {
  return X(e, ie(t, n));
}
function pe(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function ce(e) {
  return e.split("-")[0];
}
function $e(e) {
  return e.split("-")[1];
}
function kt(e) {
  return e === "x" ? "y" : "x";
}
function jt(e) {
  return e === "y" ? "height" : "width";
}
function se(e) {
  const t = e[0];
  return t === "t" || t === "b" ? "y" : "x";
}
function Bt(e) {
  return kt(se(e));
}
function zr(e, t, n) {
  n === void 0 && (n = !1);
  const o = $e(e), r = Bt(e), s = jt(r);
  let i = r === "x" ? o === (n ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return t.reference[s] > t.floating[s] && (i = tt(i)), [i, tt(i)];
}
function Vr(e) {
  const t = tt(e);
  return [Dt(e), t, Dt(t)];
}
function Dt(e) {
  return e.includes("start") ? e.replace("start", "end") : e.replace("end", "start");
}
const fn = ["left", "right"], dn = ["right", "left"], Hr = ["top", "bottom"], Gr = ["bottom", "top"];
function Yr(e, t, n) {
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? dn : fn : t ? fn : dn;
    case "left":
    case "right":
      return t ? Hr : Gr;
    default:
      return [];
  }
}
function Xr(e, t, n, o) {
  const r = $e(e);
  let s = Yr(ce(e), n === "start", o);
  return r && (s = s.map((i) => i + "-" + r), t && (s = s.concat(s.map(Dt)))), s;
}
function tt(e) {
  const t = ce(e);
  return Wr[t] + e.slice(t.length);
}
function Kr(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Wt(e) {
  return typeof e != "number" ? Kr(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Ne(e) {
  const {
    x: t,
    y: n,
    width: o,
    height: r
  } = e;
  return {
    width: o,
    height: r,
    top: n,
    left: t,
    right: t + o,
    bottom: n + r,
    x: t,
    y: n
  };
}
function pn(e, t, n) {
  let {
    reference: o,
    floating: r
  } = e;
  const s = se(t), i = Bt(t), c = jt(i), a = ce(t), l = s === "y", f = o.x + o.width / 2 - r.width / 2, p = o.y + o.height / 2 - r.height / 2, u = o[c] / 2 - r[c] / 2;
  let d;
  switch (a) {
    case "top":
      d = {
        x: f,
        y: o.y - r.height
      };
      break;
    case "bottom":
      d = {
        x: f,
        y: o.y + o.height
      };
      break;
    case "right":
      d = {
        x: o.x + o.width,
        y: p
      };
      break;
    case "left":
      d = {
        x: o.x - r.width,
        y: p
      };
      break;
    default:
      d = {
        x: o.x,
        y: o.y
      };
  }
  switch ($e(t)) {
    case "start":
      d[i] -= u * (n && l ? -1 : 1);
      break;
    case "end":
      d[i] += u * (n && l ? -1 : 1);
      break;
  }
  return d;
}
async function Ur(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: o,
    y: r,
    platform: s,
    rects: i,
    elements: c,
    strategy: a
  } = e, {
    boundary: l = "clippingAncestors",
    rootBoundary: f = "viewport",
    elementContext: p = "floating",
    altBoundary: u = !1,
    padding: d = 0
  } = pe(t, e), m = Wt(d), h = c[u ? p === "floating" ? "reference" : "floating" : p], b = Ne(await s.getClippingRect({
    element: (n = await (s.isElement == null ? void 0 : s.isElement(h))) == null || n ? h : h.contextElement || await (s.getDocumentElement == null ? void 0 : s.getDocumentElement(c.floating)),
    boundary: l,
    rootBoundary: f,
    strategy: a
  })), w = p === "floating" ? {
    x: o,
    y: r,
    width: i.floating.width,
    height: i.floating.height
  } : i.reference, v = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(c.floating)), R = await (s.isElement == null ? void 0 : s.isElement(v)) ? await (s.getScale == null ? void 0 : s.getScale(v)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, S = Ne(s.convertOffsetParentRelativeRectToViewportRelativeRect ? await s.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: c,
    rect: w,
    offsetParent: v,
    strategy: a
  }) : w);
  return {
    top: (b.top - S.top + m.top) / R.y,
    bottom: (S.bottom - b.bottom + m.bottom) / R.y,
    left: (b.left - S.left + m.left) / R.x,
    right: (S.right - b.right + m.right) / R.x
  };
}
const qr = 50, Jr = async (e, t, n) => {
  const {
    placement: o = "bottom",
    strategy: r = "absolute",
    middleware: s = [],
    platform: i
  } = n, c = i.detectOverflow ? i : {
    ...i,
    detectOverflow: Ur
  }, a = await (i.isRTL == null ? void 0 : i.isRTL(t));
  let l = await i.getElementRects({
    reference: e,
    floating: t,
    strategy: r
  }), {
    x: f,
    y: p
  } = pn(l, o, a), u = o, d = 0;
  const m = {};
  for (let g = 0; g < s.length; g++) {
    const h = s[g];
    if (!h)
      continue;
    const {
      name: b,
      fn: w
    } = h, {
      x: v,
      y: R,
      data: S,
      reset: T
    } = await w({
      x: f,
      y: p,
      initialPlacement: o,
      placement: u,
      strategy: r,
      middlewareData: m,
      rects: l,
      platform: c,
      elements: {
        reference: e,
        floating: t
      }
    });
    f = v ?? f, p = R ?? p, m[b] = {
      ...m[b],
      ...S
    }, T && d < qr && (d++, typeof T == "object" && (T.placement && (u = T.placement), T.rects && (l = T.rects === !0 ? await i.getElementRects({
      reference: e,
      floating: t,
      strategy: r
    }) : T.rects), {
      x: f,
      y: p
    } = pn(l, u, a)), g = -1);
  }
  return {
    x: f,
    y: p,
    placement: u,
    strategy: r,
    middlewareData: m
  };
}, Qr = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: o,
      placement: r,
      rects: s,
      platform: i,
      elements: c,
      middlewareData: a
    } = t, {
      element: l,
      padding: f = 0
    } = pe(e, t) || {};
    if (l == null)
      return {};
    const p = Wt(f), u = {
      x: n,
      y: o
    }, d = Bt(r), m = jt(d), g = await i.getDimensions(l), h = d === "y", b = h ? "top" : "left", w = h ? "bottom" : "right", v = h ? "clientHeight" : "clientWidth", R = s.reference[m] + s.reference[d] - u[d] - s.floating[m], S = u[d] - s.reference[d], T = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(l));
    let C = T ? T[v] : 0;
    (!C || !await (i.isElement == null ? void 0 : i.isElement(T))) && (C = c.floating[v] || s.floating[m]);
    const D = R / 2 - S / 2, _ = C / 2 - g[m] / 2 - 1, I = ie(p[b], _), j = ie(p[w], _), k = I, F = C - g[m] - j, E = C / 2 - g[m] / 2 + D, N = It(k, E, F), $ = !a.arrow && $e(r) != null && E !== N && s.reference[m] / 2 - (E < k ? I : j) - g[m] / 2 < 0, P = $ ? E < k ? E - k : E - F : 0;
    return {
      [d]: u[d] + P,
      data: {
        [d]: N,
        centerOffset: E - N - P,
        ...$ && {
          alignmentOffset: P
        }
      },
      reset: $
    };
  }
}), Zr = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, o;
      const {
        placement: r,
        middlewareData: s,
        rects: i,
        initialPlacement: c,
        platform: a,
        elements: l
      } = t, {
        mainAxis: f = !0,
        crossAxis: p = !0,
        fallbackPlacements: u,
        fallbackStrategy: d = "bestFit",
        fallbackAxisSideDirection: m = "none",
        flipAlignment: g = !0,
        ...h
      } = pe(e, t);
      if ((n = s.arrow) != null && n.alignmentOffset)
        return {};
      const b = ce(r), w = se(c), v = ce(c) === c, R = await (a.isRTL == null ? void 0 : a.isRTL(l.floating)), S = u || (v || !g ? [tt(c)] : Vr(c)), T = m !== "none";
      !u && T && S.push(...Xr(c, g, m, R));
      const C = [c, ...S], D = await a.detectOverflow(t, h), _ = [];
      let I = ((o = s.flip) == null ? void 0 : o.overflows) || [];
      if (f && _.push(D[b]), p) {
        const E = zr(r, i, R);
        _.push(D[E[0]], D[E[1]]);
      }
      if (I = [...I, {
        placement: r,
        overflows: _
      }], !_.every((E) => E <= 0)) {
        var j, k;
        const E = (((j = s.flip) == null ? void 0 : j.index) || 0) + 1, N = C[E];
        if (N && (!(p === "alignment" ? w !== se(N) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        I.every((y) => se(y.placement) === w ? y.overflows[0] > 0 : !0)))
          return {
            data: {
              index: E,
              overflows: I
            },
            reset: {
              placement: N
            }
          };
        let $ = (k = I.filter((P) => P.overflows[0] <= 0).sort((P, y) => P.overflows[1] - y.overflows[1])[0]) == null ? void 0 : k.placement;
        if (!$)
          switch (d) {
            case "bestFit": {
              var F;
              const P = (F = I.filter((y) => {
                if (T) {
                  const A = se(y.placement);
                  return A === w || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  A === "y";
                }
                return !0;
              }).map((y) => [y.placement, y.overflows.filter((A) => A > 0).reduce((A, L) => A + L, 0)]).sort((y, A) => y[1] - A[1])[0]) == null ? void 0 : F[0];
              P && ($ = P);
              break;
            }
            case "initialPlacement":
              $ = c;
              break;
          }
        if (r !== $)
          return {
            reset: {
              placement: $
            }
          };
      }
      return {};
    }
  };
};
function mn(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function gn(e) {
  return Br.some((t) => e[t] >= 0);
}
const es = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n,
        platform: o
      } = t, {
        strategy: r = "referenceHidden",
        ...s
      } = pe(e, t);
      switch (r) {
        case "referenceHidden": {
          const i = await o.detectOverflow(t, {
            ...s,
            elementContext: "reference"
          }), c = mn(i, n.reference);
          return {
            data: {
              referenceHiddenOffsets: c,
              referenceHidden: gn(c)
            }
          };
        }
        case "escaped": {
          const i = await o.detectOverflow(t, {
            ...s,
            altBoundary: !0
          }), c = mn(i, n.floating);
          return {
            data: {
              escapedOffsets: c,
              escaped: gn(c)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
function so(e) {
  const t = ie(...e.map((s) => s.left)), n = ie(...e.map((s) => s.top)), o = X(...e.map((s) => s.right)), r = X(...e.map((s) => s.bottom));
  return {
    x: t,
    y: n,
    width: o - t,
    height: r - n
  };
}
function ts(e) {
  const t = e.slice().sort((r, s) => r.y - s.y), n = [];
  let o = null;
  for (let r = 0; r < t.length; r++) {
    const s = t[r];
    !o || s.y - o.y > o.height / 2 ? n.push([s]) : n[n.length - 1].push(s), o = s;
  }
  return n.map((r) => Ne(so(r)));
}
const ns = function(e) {
  return e === void 0 && (e = {}), {
    name: "inline",
    options: e,
    async fn(t) {
      const {
        placement: n,
        elements: o,
        rects: r,
        platform: s,
        strategy: i
      } = t, {
        padding: c = 2,
        x: a,
        y: l
      } = pe(e, t), f = Array.from(await (s.getClientRects == null ? void 0 : s.getClientRects(o.reference)) || []), p = ts(f), u = Ne(so(f)), d = Wt(c);
      function m() {
        if (p.length === 2 && p[0].left > p[1].right && a != null && l != null)
          return p.find((h) => a > h.left - d.left && a < h.right + d.right && l > h.top - d.top && l < h.bottom + d.bottom) || u;
        if (p.length >= 2) {
          if (se(n) === "y") {
            const I = p[0], j = p[p.length - 1], k = ce(n) === "top", F = I.top, E = j.bottom, N = k ? I.left : j.left, $ = k ? I.right : j.right, P = $ - N, y = E - F;
            return {
              top: F,
              bottom: E,
              left: N,
              right: $,
              width: P,
              height: y,
              x: N,
              y: F
            };
          }
          const h = ce(n) === "left", b = X(...p.map((I) => I.right)), w = ie(...p.map((I) => I.left)), v = p.filter((I) => h ? I.left === w : I.right === b), R = v[0].top, S = v[v.length - 1].bottom, T = w, C = b, D = C - T, _ = S - R;
          return {
            top: R,
            bottom: S,
            left: T,
            right: C,
            width: D,
            height: _,
            x: T,
            y: R
          };
        }
        return u;
      }
      const g = await s.getElementRects({
        reference: {
          getBoundingClientRect: m
        },
        floating: o.floating,
        strategy: i
      });
      return r.reference.x !== g.reference.x || r.reference.y !== g.reference.y || r.reference.width !== g.reference.width || r.reference.height !== g.reference.height ? {
        reset: {
          rects: g
        }
      } : {};
    }
  };
}, io = /* @__PURE__ */ new Set(["left", "top"]);
async function os(e, t) {
  const {
    placement: n,
    platform: o,
    elements: r
  } = e, s = await (o.isRTL == null ? void 0 : o.isRTL(r.floating)), i = ce(n), c = $e(n), a = se(n) === "y", l = io.has(i) ? -1 : 1, f = s && a ? -1 : 1, p = pe(t, e);
  let {
    mainAxis: u,
    crossAxis: d,
    alignmentAxis: m
  } = typeof p == "number" ? {
    mainAxis: p,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: p.mainAxis || 0,
    crossAxis: p.crossAxis || 0,
    alignmentAxis: p.alignmentAxis
  };
  return c && typeof m == "number" && (d = c === "end" ? m * -1 : m), a ? {
    x: d * f,
    y: u * l
  } : {
    x: u * l,
    y: d * f
  };
}
const rs = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, o;
      const {
        x: r,
        y: s,
        placement: i,
        middlewareData: c
      } = t, a = await os(t, e);
      return i === ((n = c.offset) == null ? void 0 : n.placement) && (o = c.arrow) != null && o.alignmentOffset ? {} : {
        x: r + a.x,
        y: s + a.y,
        data: {
          ...a,
          placement: i
        }
      };
    }
  };
}, ss = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: o,
        placement: r,
        platform: s
      } = t, {
        mainAxis: i = !0,
        crossAxis: c = !1,
        limiter: a = {
          fn: (b) => {
            let {
              x: w,
              y: v
            } = b;
            return {
              x: w,
              y: v
            };
          }
        },
        ...l
      } = pe(e, t), f = {
        x: n,
        y: o
      }, p = await s.detectOverflow(t, l), u = se(ce(r)), d = kt(u);
      let m = f[d], g = f[u];
      if (i) {
        const b = d === "y" ? "top" : "left", w = d === "y" ? "bottom" : "right", v = m + p[b], R = m - p[w];
        m = It(v, m, R);
      }
      if (c) {
        const b = u === "y" ? "top" : "left", w = u === "y" ? "bottom" : "right", v = g + p[b], R = g - p[w];
        g = It(v, g, R);
      }
      const h = a.fn({
        ...t,
        [d]: m,
        [u]: g
      });
      return {
        ...h,
        data: {
          x: h.x - n,
          y: h.y - o,
          enabled: {
            [d]: i,
            [u]: c
          }
        }
      };
    }
  };
}, is = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: o,
        placement: r,
        rects: s,
        middlewareData: i
      } = t, {
        offset: c = 0,
        mainAxis: a = !0,
        crossAxis: l = !0
      } = pe(e, t), f = {
        x: n,
        y: o
      }, p = se(r), u = kt(p);
      let d = f[u], m = f[p];
      const g = pe(c, t), h = typeof g == "number" ? {
        mainAxis: g,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...g
      };
      if (a) {
        const v = u === "y" ? "height" : "width", R = s.reference[u] - s.floating[v] + h.mainAxis, S = s.reference[u] + s.reference[v] - h.mainAxis;
        d < R ? d = R : d > S && (d = S);
      }
      if (l) {
        var b, w;
        const v = u === "y" ? "width" : "height", R = io.has(ce(r)), S = s.reference[p] - s.floating[v] + (R && ((b = i.offset) == null ? void 0 : b[p]) || 0) + (R ? 0 : h.crossAxis), T = s.reference[p] + s.reference[v] + (R ? 0 : ((w = i.offset) == null ? void 0 : w[p]) || 0) - (R ? h.crossAxis : 0);
        m < S ? m = S : m > T && (m = T);
      }
      return {
        [u]: d,
        [p]: m
      };
    }
  };
}, cs = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, o;
      const {
        placement: r,
        rects: s,
        platform: i,
        elements: c
      } = t, {
        apply: a = () => {
        },
        ...l
      } = pe(e, t), f = await i.detectOverflow(t, l), p = ce(r), u = $e(r), d = se(r) === "y", {
        width: m,
        height: g
      } = s.floating;
      let h, b;
      p === "top" || p === "bottom" ? (h = p, b = u === (await (i.isRTL == null ? void 0 : i.isRTL(c.floating)) ? "start" : "end") ? "left" : "right") : (b = p, h = u === "end" ? "top" : "bottom");
      const w = g - f.top - f.bottom, v = m - f.left - f.right, R = ie(g - f[h], w), S = ie(m - f[b], v), T = !t.middlewareData.shift;
      let C = R, D = S;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (D = v), (o = t.middlewareData.shift) != null && o.enabled.y && (C = w), T && !u) {
        const I = X(f.left, 0), j = X(f.right, 0), k = X(f.top, 0), F = X(f.bottom, 0);
        d ? D = m - 2 * (I !== 0 || j !== 0 ? I + j : X(f.left, f.right)) : C = g - 2 * (k !== 0 || F !== 0 ? k + F : X(f.top, f.bottom));
      }
      await a({
        ...t,
        availableWidth: D,
        availableHeight: C
      });
      const _ = await i.getDimensions(c.floating);
      return m !== _.width || g !== _.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function st() {
  return typeof window < "u";
}
function Me(e) {
  return co(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Z(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function me(e) {
  var t;
  return (t = (co(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function co(e) {
  return st() ? e instanceof Node || e instanceof Z(e).Node : !1;
}
function ae(e) {
  return st() ? e instanceof Element || e instanceof Z(e).Element : !1;
}
function ye(e) {
  return st() ? e instanceof HTMLElement || e instanceof Z(e).HTMLElement : !1;
}
function hn(e) {
  return !st() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Z(e).ShadowRoot;
}
function He(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: o,
    display: r
  } = le(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + o + n) && r !== "inline" && r !== "contents";
}
function as(e) {
  return /^(table|td|th)$/.test(Me(e));
}
function it(e) {
  try {
    if (e.matches(":popover-open"))
      return !0;
  } catch {
  }
  try {
    return e.matches(":modal");
  } catch {
    return !1;
  }
}
const ls = /transform|translate|scale|rotate|perspective|filter/, us = /paint|layout|strict|content/, Pe = (e) => !!e && e !== "none";
let bt;
function zt(e) {
  const t = ae(e) ? le(e) : e;
  return Pe(t.transform) || Pe(t.translate) || Pe(t.scale) || Pe(t.rotate) || Pe(t.perspective) || !Vt() && (Pe(t.backdropFilter) || Pe(t.filter)) || ls.test(t.willChange || "") || us.test(t.contain || "");
}
function fs(e) {
  let t = Re(e);
  for (; ye(t) && !_e(t); ) {
    if (zt(t))
      return t;
    if (it(t))
      return null;
    t = Re(t);
  }
  return null;
}
function Vt() {
  return bt == null && (bt = typeof CSS < "u" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none")), bt;
}
function _e(e) {
  return /^(html|body|#document)$/.test(Me(e));
}
function le(e) {
  return Z(e).getComputedStyle(e);
}
function ct(e) {
  return ae(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function Re(e) {
  if (Me(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    hn(e) && e.host || // Fallback.
    me(e)
  );
  return hn(t) ? t.host : t;
}
function ao(e) {
  const t = Re(e);
  return _e(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : ye(t) && He(t) ? t : ao(t);
}
function xe(e, t, n) {
  var o;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const r = ao(e), s = r === ((o = e.ownerDocument) == null ? void 0 : o.body), i = Z(r);
  if (s) {
    const c = Nt(i);
    return t.concat(i, i.visualViewport || [], He(r) ? r : [], c && n ? xe(c) : []);
  } else
    return t.concat(r, xe(r, [], n));
}
function Nt(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function lo(e) {
  const t = le(e);
  let n = parseFloat(t.width) || 0, o = parseFloat(t.height) || 0;
  const r = ye(e), s = r ? e.offsetWidth : n, i = r ? e.offsetHeight : o, c = et(n) !== s || et(o) !== i;
  return c && (n = s, o = i), {
    width: n,
    height: o,
    $: c
  };
}
function Ht(e) {
  return ae(e) ? e : e.contextElement;
}
function De(e) {
  const t = Ht(e);
  if (!ye(t))
    return de(1);
  const n = t.getBoundingClientRect(), {
    width: o,
    height: r,
    $: s
  } = lo(t);
  let i = (s ? et(n.width) : n.width) / o, c = (s ? et(n.height) : n.height) / r;
  return (!i || !Number.isFinite(i)) && (i = 1), (!c || !Number.isFinite(c)) && (c = 1), {
    x: i,
    y: c
  };
}
const ds = /* @__PURE__ */ de(0);
function uo(e) {
  const t = Z(e);
  return !Vt() || !t.visualViewport ? ds : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function ps(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== Z(e) ? !1 : t;
}
function Oe(e, t, n, o) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const r = e.getBoundingClientRect(), s = Ht(e);
  let i = de(1);
  t && (o ? ae(o) && (i = De(o)) : i = De(e));
  const c = ps(s, n, o) ? uo(s) : de(0);
  let a = (r.left + c.x) / i.x, l = (r.top + c.y) / i.y, f = r.width / i.x, p = r.height / i.y;
  if (s) {
    const u = Z(s), d = o && ae(o) ? Z(o) : o;
    let m = u, g = Nt(m);
    for (; g && o && d !== m; ) {
      const h = De(g), b = g.getBoundingClientRect(), w = le(g), v = b.left + (g.clientLeft + parseFloat(w.paddingLeft)) * h.x, R = b.top + (g.clientTop + parseFloat(w.paddingTop)) * h.y;
      a *= h.x, l *= h.y, f *= h.x, p *= h.y, a += v, l += R, m = Z(g), g = Nt(m);
    }
  }
  return Ne({
    width: f,
    height: p,
    x: a,
    y: l
  });
}
function at(e, t) {
  const n = ct(e).scrollLeft;
  return t ? t.left + n : Oe(me(e)).left + n;
}
function fo(e, t) {
  const n = e.getBoundingClientRect(), o = n.left + t.scrollLeft - at(e, n), r = n.top + t.scrollTop;
  return {
    x: o,
    y: r
  };
}
function ms(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: o,
    strategy: r
  } = e;
  const s = r === "fixed", i = me(o), c = t ? it(t.floating) : !1;
  if (o === i || c && s)
    return n;
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = de(1);
  const f = de(0), p = ye(o);
  if ((p || !p && !s) && ((Me(o) !== "body" || He(i)) && (a = ct(o)), p)) {
    const d = Oe(o);
    l = De(o), f.x = d.x + o.clientLeft, f.y = d.y + o.clientTop;
  }
  const u = i && !p && !s ? fo(i, a) : de(0);
  return {
    width: n.width * l.x,
    height: n.height * l.y,
    x: n.x * l.x - a.scrollLeft * l.x + f.x + u.x,
    y: n.y * l.y - a.scrollTop * l.y + f.y + u.y
  };
}
function gs(e) {
  return Array.from(e.getClientRects());
}
function hs(e) {
  const t = me(e), n = ct(e), o = e.ownerDocument.body, r = X(t.scrollWidth, t.clientWidth, o.scrollWidth, o.clientWidth), s = X(t.scrollHeight, t.clientHeight, o.scrollHeight, o.clientHeight);
  let i = -n.scrollLeft + at(e);
  const c = -n.scrollTop;
  return le(o).direction === "rtl" && (i += X(t.clientWidth, o.clientWidth) - r), {
    width: r,
    height: s,
    x: i,
    y: c
  };
}
const vn = 25;
function vs(e, t) {
  const n = Z(e), o = me(e), r = n.visualViewport;
  let s = o.clientWidth, i = o.clientHeight, c = 0, a = 0;
  if (r) {
    s = r.width, i = r.height;
    const f = Vt();
    (!f || f && t === "fixed") && (c = r.offsetLeft, a = r.offsetTop);
  }
  const l = at(o);
  if (l <= 0) {
    const f = o.ownerDocument, p = f.body, u = getComputedStyle(p), d = f.compatMode === "CSS1Compat" && parseFloat(u.marginLeft) + parseFloat(u.marginRight) || 0, m = Math.abs(o.clientWidth - p.clientWidth - d);
    m <= vn && (s -= m);
  } else l <= vn && (s += l);
  return {
    width: s,
    height: i,
    x: c,
    y: a
  };
}
function ys(e, t) {
  const n = Oe(e, !0, t === "fixed"), o = n.top + e.clientTop, r = n.left + e.clientLeft, s = ye(e) ? De(e) : de(1), i = e.clientWidth * s.x, c = e.clientHeight * s.y, a = r * s.x, l = o * s.y;
  return {
    width: i,
    height: c,
    x: a,
    y: l
  };
}
function yn(e, t, n) {
  let o;
  if (t === "viewport")
    o = vs(e, n);
  else if (t === "document")
    o = hs(me(e));
  else if (ae(t))
    o = ys(t, n);
  else {
    const r = uo(e);
    o = {
      x: t.x - r.x,
      y: t.y - r.y,
      width: t.width,
      height: t.height
    };
  }
  return Ne(o);
}
function po(e, t) {
  const n = Re(e);
  return n === t || !ae(n) || _e(n) ? !1 : le(n).position === "fixed" || po(n, t);
}
function ws(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let o = xe(e, [], !1).filter((c) => ae(c) && Me(c) !== "body"), r = null;
  const s = le(e).position === "fixed";
  let i = s ? Re(e) : e;
  for (; ae(i) && !_e(i); ) {
    const c = le(i), a = zt(i);
    !a && c.position === "fixed" && (r = null), (s ? !a && !r : !a && c.position === "static" && !!r && (r.position === "absolute" || r.position === "fixed") || He(i) && !a && po(e, i)) ? o = o.filter((f) => f !== i) : r = c, i = Re(i);
  }
  return t.set(e, o), o;
}
function bs(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: o,
    strategy: r
  } = e;
  const i = [...n === "clippingAncestors" ? it(t) ? [] : ws(t, this._c) : [].concat(n), o], c = yn(t, i[0], r);
  let a = c.top, l = c.right, f = c.bottom, p = c.left;
  for (let u = 1; u < i.length; u++) {
    const d = yn(t, i[u], r);
    a = X(d.top, a), l = ie(d.right, l), f = ie(d.bottom, f), p = X(d.left, p);
  }
  return {
    width: l - p,
    height: f - a,
    x: p,
    y: a
  };
}
function xs(e) {
  const {
    width: t,
    height: n
  } = lo(e);
  return {
    width: t,
    height: n
  };
}
function Rs(e, t, n) {
  const o = ye(t), r = me(t), s = n === "fixed", i = Oe(e, !0, s, t);
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const a = de(0);
  function l() {
    a.x = at(r);
  }
  if (o || !o && !s)
    if ((Me(t) !== "body" || He(r)) && (c = ct(t)), o) {
      const d = Oe(t, !0, s, t);
      a.x = d.x + t.clientLeft, a.y = d.y + t.clientTop;
    } else r && l();
  s && !o && r && l();
  const f = r && !o && !s ? fo(r, c) : de(0), p = i.left + c.scrollLeft - a.x - f.x, u = i.top + c.scrollTop - a.y - f.y;
  return {
    x: p,
    y: u,
    width: i.width,
    height: i.height
  };
}
function xt(e) {
  return le(e).position === "static";
}
function wn(e, t) {
  if (!ye(e) || le(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return me(e) === n && (n = n.ownerDocument.body), n;
}
function mo(e, t) {
  const n = Z(e);
  if (it(e))
    return n;
  if (!ye(e)) {
    let r = Re(e);
    for (; r && !_e(r); ) {
      if (ae(r) && !xt(r))
        return r;
      r = Re(r);
    }
    return n;
  }
  let o = wn(e, t);
  for (; o && as(o) && xt(o); )
    o = wn(o, t);
  return o && _e(o) && xt(o) && !zt(o) ? n : o || fs(e) || n;
}
const Es = async function(e) {
  const t = this.getOffsetParent || mo, n = this.getDimensions, o = await n(e.floating);
  return {
    reference: Rs(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: o.width,
      height: o.height
    }
  };
};
function Cs(e) {
  return le(e).direction === "rtl";
}
const Ss = {
  convertOffsetParentRelativeRectToViewportRelativeRect: ms,
  getDocumentElement: me,
  getClippingRect: bs,
  getOffsetParent: mo,
  getElementRects: Es,
  getClientRects: gs,
  getDimensions: xs,
  getScale: De,
  isElement: ae,
  isRTL: Cs
};
function go(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function Ps(e, t) {
  let n = null, o;
  const r = me(e);
  function s() {
    var c;
    clearTimeout(o), (c = n) == null || c.disconnect(), n = null;
  }
  function i(c, a) {
    c === void 0 && (c = !1), a === void 0 && (a = 1), s();
    const l = e.getBoundingClientRect(), {
      left: f,
      top: p,
      width: u,
      height: d
    } = l;
    if (c || t(), !u || !d)
      return;
    const m = Ke(p), g = Ke(r.clientWidth - (f + u)), h = Ke(r.clientHeight - (p + d)), b = Ke(f), v = {
      rootMargin: -m + "px " + -g + "px " + -h + "px " + -b + "px",
      threshold: X(0, ie(1, a)) || 1
    };
    let R = !0;
    function S(T) {
      const C = T[0].intersectionRatio;
      if (C !== a) {
        if (!R)
          return i();
        C ? i(!1, C) : o = setTimeout(() => {
          i(!1, 1e-7);
        }, 1e3);
      }
      C === 1 && !go(l, e.getBoundingClientRect()) && i(), R = !1;
    }
    try {
      n = new IntersectionObserver(S, {
        ...v,
        // Handle <iframe>s
        root: r.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(S, v);
    }
    n.observe(e);
  }
  return i(!0), s;
}
function bn(e, t, n, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: r = !0,
    ancestorResize: s = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: c = typeof IntersectionObserver == "function",
    animationFrame: a = !1
  } = o, l = Ht(e), f = r || s ? [...l ? xe(l) : [], ...t ? xe(t) : []] : [];
  f.forEach((b) => {
    r && b.addEventListener("scroll", n, {
      passive: !0
    }), s && b.addEventListener("resize", n);
  });
  const p = l && c ? Ps(l, n) : null;
  let u = -1, d = null;
  i && (d = new ResizeObserver((b) => {
    let [w] = b;
    w && w.target === l && d && t && (d.unobserve(t), cancelAnimationFrame(u), u = requestAnimationFrame(() => {
      var v;
      (v = d) == null || v.observe(t);
    })), n();
  }), l && !a && d.observe(l), t && d.observe(t));
  let m, g = a ? Oe(e) : null;
  a && h();
  function h() {
    const b = Oe(e);
    g && !go(g, b) && n(), g = b, m = requestAnimationFrame(h);
  }
  return n(), () => {
    var b;
    f.forEach((w) => {
      r && w.removeEventListener("scroll", n), s && w.removeEventListener("resize", n);
    }), p?.(), (b = d) == null || b.disconnect(), d = null, a && cancelAnimationFrame(m);
  };
}
const Ts = rs, Os = ss, As = Zr, Is = cs, Ds = es, xn = Qr, Ns = ns, _s = is, Ls = (e, t, n) => {
  const o = /* @__PURE__ */ new Map(), r = {
    platform: Ss,
    ...n
  }, s = {
    ...r.platform,
    _c: o
  };
  return Jr(e, t, {
    ...r,
    platform: s
  });
};
var $s = typeof document < "u", Ms = function() {
}, Je = $s ? Bn : Ms;
function nt(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, o, r;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (o = n; o-- !== 0; )
        if (!nt(e[o], t[o]))
          return !1;
      return !0;
    }
    if (r = Object.keys(e), n = r.length, n !== Object.keys(t).length)
      return !1;
    for (o = n; o-- !== 0; )
      if (!{}.hasOwnProperty.call(t, r[o]))
        return !1;
    for (o = n; o-- !== 0; ) {
      const s = r[o];
      if (!(s === "_owner" && e.$$typeof) && !nt(e[s], t[s]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function ho(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Rn(e, t) {
  const n = ho(e);
  return Math.round(t * n) / n;
}
function Rt(e) {
  const t = x.useRef(e);
  return Je(() => {
    t.current = e;
  }), t;
}
function Fs(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: o = [],
    platform: r,
    elements: {
      reference: s,
      floating: i
    } = {},
    transform: c = !0,
    whileElementsMounted: a,
    open: l
  } = e, [f, p] = x.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [u, d] = x.useState(o);
  nt(u, o) || d(o);
  const [m, g] = x.useState(null), [h, b] = x.useState(null), w = x.useCallback((y) => {
    y !== T.current && (T.current = y, g(y));
  }, []), v = x.useCallback((y) => {
    y !== C.current && (C.current = y, b(y));
  }, []), R = s || m, S = i || h, T = x.useRef(null), C = x.useRef(null), D = x.useRef(f), _ = a != null, I = Rt(a), j = Rt(r), k = Rt(l), F = x.useCallback(() => {
    if (!T.current || !C.current)
      return;
    const y = {
      placement: t,
      strategy: n,
      middleware: u
    };
    j.current && (y.platform = j.current), Ls(T.current, C.current, y).then((A) => {
      const L = {
        ...A,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: k.current !== !1
      };
      E.current && !nt(D.current, L) && (D.current = L, tr.flushSync(() => {
        p(L);
      }));
    });
  }, [u, t, n, j, k]);
  Je(() => {
    l === !1 && D.current.isPositioned && (D.current.isPositioned = !1, p((y) => ({
      ...y,
      isPositioned: !1
    })));
  }, [l]);
  const E = x.useRef(!1);
  Je(() => (E.current = !0, () => {
    E.current = !1;
  }), []), Je(() => {
    if (R && (T.current = R), S && (C.current = S), R && S) {
      if (I.current)
        return I.current(R, S, F);
      F();
    }
  }, [R, S, F, I, _]);
  const N = x.useMemo(() => ({
    reference: T,
    floating: C,
    setReference: w,
    setFloating: v
  }), [w, v]), $ = x.useMemo(() => ({
    reference: R,
    floating: S
  }), [R, S]), P = x.useMemo(() => {
    const y = {
      position: n,
      left: 0,
      top: 0
    };
    if (!$.floating)
      return y;
    const A = Rn($.floating, f.x), L = Rn($.floating, f.y);
    return c ? {
      ...y,
      transform: "translate(" + A + "px, " + L + "px)",
      ...ho($.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: A,
      top: L
    };
  }, [n, c, $.floating, f.x, f.y]);
  return x.useMemo(() => ({
    ...f,
    update: F,
    refs: N,
    elements: $,
    floatingStyles: P
  }), [f, F, N, $, P]);
}
const ks = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: o,
        padding: r
      } = typeof e == "function" ? e(n) : e;
      return o && t(o) ? o.current != null ? xn({
        element: o.current,
        padding: r
      }).fn(n) : {} : o ? xn({
        element: o,
        padding: r
      }).fn(n) : {};
    }
  };
}, js = (e, t) => ({
  ...Ts(e),
  options: [e, t]
}), Bs = (e, t) => ({
  ...Os(e),
  options: [e, t]
}), En = (e, t) => ({
  ..._s(e),
  options: [e, t]
}), Cn = (e, t) => ({
  ...As(e),
  options: [e, t]
}), Ws = (e, t) => ({
  ...Is(e),
  options: [e, t]
}), zs = (e, t) => ({
  ...Ds(e),
  options: [e, t]
}), Sn = (e, t) => ({
  ...Ns(e),
  options: [e, t]
}), Vs = (e, t) => ({
  ...ks(e),
  options: [e, t]
});
function qi(e) {
  const t = x.useRef(void 0), n = x.useCallback((o) => {
    const r = e.map((s) => {
      if (s != null) {
        if (typeof s == "function") {
          const i = s, c = i(o);
          return typeof c == "function" ? c : () => {
            i(null);
          };
        }
        return s.current = o, () => {
          s.current = null;
        };
      }
    });
    return () => {
      r.forEach((s) => s?.());
    };
  }, e);
  return x.useMemo(() => e.every((o) => o == null) ? null : (o) => {
    t.current && (t.current(), t.current = void 0), o != null && (t.current = n(o));
  }, e);
}
const Hs = "data-floating-ui-focusable", Pn = "active", Tn = "selected", Gs = {
  ...x
};
let On = !1, Ys = 0;
const An = () => (
  // Ensure the id is unique with multiple independent versions of Floating UI
  // on <React 18
  "floating-ui-" + Math.random().toString(36).slice(2, 6) + Ys++
);
function Xs() {
  const [e, t] = x.useState(() => On ? An() : void 0);
  return fe(() => {
    e == null && t(An());
  }, []), x.useEffect(() => {
    On = !0;
  }, []), e;
}
const Ks = Gs.useId, vo = Ks || Xs;
let _t;
process.env.NODE_ENV !== "production" && (_t = /* @__PURE__ */ new Set());
function Us() {
  for (var e, t = arguments.length, n = new Array(t), o = 0; o < t; o++)
    n[o] = arguments[o];
  const r = "Floating UI: " + n.join(" ");
  if (!((e = _t) != null && e.has(r))) {
    var s;
    (s = _t) == null || s.add(r), console.error(r);
  }
}
function qs() {
  const e = /* @__PURE__ */ new Map();
  return {
    emit(t, n) {
      var o;
      (o = e.get(t)) == null || o.forEach((r) => r(n));
    },
    on(t, n) {
      e.has(t) || e.set(t, /* @__PURE__ */ new Set()), e.get(t).add(n);
    },
    off(t, n) {
      var o;
      (o = e.get(t)) == null || o.delete(n);
    }
  };
}
const Js = /* @__PURE__ */ x.createContext(null), Qs = /* @__PURE__ */ x.createContext(null), Gt = () => {
  var e;
  return ((e = x.useContext(Js)) == null ? void 0 : e.id) || null;
}, Yt = () => x.useContext(Qs);
function Xt(e) {
  return "data-floating-ui-" + e;
}
function ne(e) {
  e.current !== -1 && (clearTimeout(e.current), e.current = -1);
}
const In = /* @__PURE__ */ Xt("safe-polygon");
function Qe(e, t, n) {
  if (n && !At(n))
    return 0;
  if (typeof e == "number")
    return e;
  if (typeof e == "function") {
    const o = e();
    return typeof o == "number" ? o : o?.[t];
  }
  return e?.[t];
}
function Et(e) {
  return typeof e == "function" ? e() : e;
}
function Ji(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: o,
    dataRef: r,
    events: s,
    elements: i
  } = e, {
    enabled: c = !0,
    delay: a = 0,
    handleClose: l = null,
    mouseOnly: f = !1,
    restMs: p = 0,
    move: u = !0
  } = t, d = Yt(), m = Gt(), g = Xe(l), h = Xe(a), b = Xe(n), w = Xe(p), v = x.useRef(), R = x.useRef(-1), S = x.useRef(), T = x.useRef(-1), C = x.useRef(!0), D = x.useRef(!1), _ = x.useRef(() => {
  }), I = x.useRef(!1), j = ue(() => {
    var P;
    const y = (P = r.current.openEvent) == null ? void 0 : P.type;
    return y?.includes("mouse") && y !== "mousedown";
  });
  x.useEffect(() => {
    if (!c) return;
    function P(y) {
      let {
        open: A
      } = y;
      A || (ne(R), ne(T), C.current = !0, I.current = !1);
    }
    return s.on("openchange", P), () => {
      s.off("openchange", P);
    };
  }, [c, s]), x.useEffect(() => {
    if (!c || !g.current || !n) return;
    function P(A) {
      j() && o(!1, A, "hover");
    }
    const y = Te(i.floating).documentElement;
    return y.addEventListener("mouseleave", P), () => {
      y.removeEventListener("mouseleave", P);
    };
  }, [i.floating, n, o, c, g, j]);
  const k = x.useCallback(function(P, y, A) {
    y === void 0 && (y = !0), A === void 0 && (A = "hover");
    const L = Qe(h.current, "close", v.current);
    L && !S.current ? (ne(R), R.current = window.setTimeout(() => o(!1, P, A), L)) : y && (ne(R), o(!1, P, A));
  }, [h, o]), F = ue(() => {
    _.current(), S.current = void 0;
  }), E = ue(() => {
    if (D.current) {
      const P = Te(i.floating).body;
      P.style.pointerEvents = "", P.removeAttribute(In), D.current = !1;
    }
  }), N = ue(() => r.current.openEvent ? ["click", "mousedown"].includes(r.current.openEvent.type) : !1);
  x.useEffect(() => {
    if (!c) return;
    function P(M) {
      if (ne(R), C.current = !1, f && !At(v.current) || Et(w.current) > 0 && !Qe(h.current, "open"))
        return;
      const B = Qe(h.current, "open", v.current);
      B ? R.current = window.setTimeout(() => {
        b.current || o(!0, M, "hover");
      }, B) : n || o(!0, M, "hover");
    }
    function y(M) {
      if (N()) {
        E();
        return;
      }
      _.current();
      const B = Te(i.floating);
      if (ne(T), I.current = !1, g.current && r.current.floatingContext) {
        n || ne(R), S.current = g.current({
          ...r.current.floatingContext,
          tree: d,
          x: M.clientX,
          y: M.clientY,
          onClose() {
            E(), F(), N() || k(M, !0, "safe-polygon");
          }
        });
        const W = S.current;
        B.addEventListener("mousemove", W), _.current = () => {
          B.removeEventListener("mousemove", W);
        };
        return;
      }
      (v.current !== "touch" || !ze(i.floating, M.relatedTarget)) && k(M);
    }
    function A(M) {
      N() || r.current.floatingContext && (g.current == null || g.current({
        ...r.current.floatingContext,
        tree: d,
        x: M.clientX,
        y: M.clientY,
        onClose() {
          E(), F(), N() || k(M);
        }
      })(M));
    }
    function L() {
      ne(R);
    }
    function V(M) {
      N() || k(M, !1);
    }
    if (U(i.domReference)) {
      const M = i.domReference, B = i.floating;
      return n && M.addEventListener("mouseleave", A), u && M.addEventListener("mousemove", P, {
        once: !0
      }), M.addEventListener("mouseenter", P), M.addEventListener("mouseleave", y), B && (B.addEventListener("mouseleave", A), B.addEventListener("mouseenter", L), B.addEventListener("mouseleave", V)), () => {
        n && M.removeEventListener("mouseleave", A), u && M.removeEventListener("mousemove", P), M.removeEventListener("mouseenter", P), M.removeEventListener("mouseleave", y), B && (B.removeEventListener("mouseleave", A), B.removeEventListener("mouseenter", L), B.removeEventListener("mouseleave", V));
      };
    }
  }, [i, c, e, f, u, k, F, E, o, n, b, d, h, g, r, N, w]), fe(() => {
    var P;
    if (c && n && (P = g.current) != null && (P = P.__options) != null && P.blockPointerEvents && j()) {
      D.current = !0;
      const A = i.floating;
      if (U(i.domReference) && A) {
        var y;
        const L = Te(i.floating).body;
        L.setAttribute(In, "");
        const V = i.domReference, M = d == null || (y = d.nodesRef.current.find((B) => B.id === m)) == null || (y = y.context) == null ? void 0 : y.elements.floating;
        return M && (M.style.pointerEvents = ""), L.style.pointerEvents = "none", V.style.pointerEvents = "auto", A.style.pointerEvents = "auto", () => {
          L.style.pointerEvents = "", V.style.pointerEvents = "", A.style.pointerEvents = "";
        };
      }
    }
  }, [c, n, m, i, d, g, j]), fe(() => {
    n || (v.current = void 0, I.current = !1, F(), E());
  }, [n, F, E]), x.useEffect(() => () => {
    F(), ne(R), ne(T), E();
  }, [c, i.domReference, F, E]);
  const $ = x.useMemo(() => {
    function P(y) {
      v.current = y.pointerType;
    }
    return {
      onPointerDown: P,
      onPointerEnter: P,
      onMouseMove(y) {
        const {
          nativeEvent: A
        } = y;
        function L() {
          !C.current && !b.current && o(!0, A, "hover");
        }
        f && !At(v.current) || n || Et(w.current) === 0 || I.current && y.movementX ** 2 + y.movementY ** 2 < 2 || (ne(T), v.current === "touch" ? L() : (I.current = !0, T.current = window.setTimeout(L, Et(w.current))));
      }
    };
  }, [f, o, n, b, w]);
  return x.useMemo(() => c ? {
    reference: $
  } : {}, [c, $]);
}
const Lt = () => {
}, yo = /* @__PURE__ */ x.createContext({
  delay: 0,
  initialDelay: 0,
  timeoutMs: 0,
  currentId: null,
  setCurrentId: Lt,
  setState: Lt,
  isInstantPhase: !1
}), Zs = () => x.useContext(yo);
function Qi(e) {
  const {
    children: t,
    delay: n,
    timeoutMs: o = 0
  } = e, [r, s] = x.useReducer((a, l) => ({
    ...a,
    ...l
  }), {
    delay: n,
    timeoutMs: o,
    initialDelay: n,
    currentId: null,
    isInstantPhase: !1
  }), i = x.useRef(null), c = x.useCallback((a) => {
    s({
      currentId: a
    });
  }, []);
  return fe(() => {
    r.currentId ? i.current === null ? i.current = r.currentId : r.isInstantPhase || s({
      isInstantPhase: !0
    }) : (r.isInstantPhase && s({
      isInstantPhase: !1
    }), i.current = null);
  }, [r.currentId, r.isInstantPhase]), /* @__PURE__ */ O.jsx(yo.Provider, {
    value: x.useMemo(() => ({
      ...r,
      setState: s,
      setCurrentId: c
    }), [r, c]),
    children: t
  });
}
function Zi(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: o,
    floatingId: r
  } = e, {
    id: s,
    enabled: i = !0
  } = t, c = s ?? r, a = Zs(), {
    currentId: l,
    setCurrentId: f,
    initialDelay: p,
    setState: u,
    timeoutMs: d
  } = a;
  return fe(() => {
    i && l && (u({
      delay: {
        open: 1,
        close: Qe(p, "close")
      }
    }), l !== c && o(!1));
  }, [i, c, o, u, l, p]), fe(() => {
    function m() {
      o(!1), u({
        delay: p,
        currentId: null
      });
    }
    if (i && l && !n && l === c) {
      if (d) {
        const g = window.setTimeout(m, d);
        return () => {
          clearTimeout(g);
        };
      }
      m();
    }
  }, [i, n, u, l, c, o, p, d]), fe(() => {
    i && (f === Lt || !n || f(c));
  }, [i, n, f, c]), a;
}
const ei = {
  pointerdown: "onPointerDown",
  mousedown: "onMouseDown",
  click: "onClick"
}, ti = {
  pointerdown: "onPointerDownCapture",
  mousedown: "onMouseDownCapture",
  click: "onClickCapture"
}, Dn = (e) => {
  var t, n;
  return {
    escapeKey: typeof e == "boolean" ? e : (t = e?.escapeKey) != null ? t : !1,
    outsidePress: typeof e == "boolean" ? e : (n = e?.outsidePress) != null ? n : !0
  };
};
function ec(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: o,
    elements: r,
    dataRef: s
  } = e, {
    enabled: i = !0,
    escapeKey: c = !0,
    outsidePress: a = !0,
    outsidePressEvent: l = "pointerdown",
    referencePress: f = !1,
    referencePressEvent: p = "pointerdown",
    ancestorScroll: u = !1,
    bubbles: d,
    capture: m
  } = t, g = Yt(), h = ue(typeof a == "function" ? a : () => !1), b = typeof a == "function" ? h : a, w = x.useRef(!1), {
    escapeKey: v,
    outsidePress: R
  } = Dn(d), {
    escapeKey: S,
    outsidePress: T
  } = Dn(m), C = x.useRef(!1), D = ue((E) => {
    var N;
    if (!n || !i || !c || E.key !== "Escape" || C.current)
      return;
    const $ = (N = s.current.floatingContext) == null ? void 0 : N.nodeId, P = g ? qe(g.nodesRef.current, $) : [];
    if (!v && (E.stopPropagation(), P.length > 0)) {
      let y = !0;
      if (P.forEach((A) => {
        var L;
        if ((L = A.context) != null && L.open && !A.context.dataRef.current.__escapeKeyBubbles) {
          y = !1;
          return;
        }
      }), !y)
        return;
    }
    o(!1, Lr(E) ? E.nativeEvent : E, "escape-key");
  }), _ = ue((E) => {
    var N;
    const $ = () => {
      var P;
      D(E), (P = Ie(E)) == null || P.removeEventListener("keydown", $);
    };
    (N = Ie(E)) == null || N.addEventListener("keydown", $);
  }), I = ue((E) => {
    var N;
    const $ = s.current.insideReactTree;
    s.current.insideReactTree = !1;
    const P = w.current;
    if (w.current = !1, l === "click" && P || $ || typeof b == "function" && !b(E))
      return;
    const y = Ie(E), A = "[" + Xt("inert") + "]", L = Te(r.floating).querySelectorAll(A);
    let V = U(y) ? y : null;
    for (; V && !yt(V); ) {
      const W = Er(V);
      if (yt(W) || !U(W))
        break;
      V = W;
    }
    if (L.length && U(y) && !Ir(y) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
    !ze(y, r.floating) && // If the target root element contains none of the markers, then the
    // element was injected after the floating element rendered.
    Array.from(L).every((W) => !ze(V, W)))
      return;
    if (Ft(y) && F) {
      const W = yt(y), G = Rr(y), te = /auto|scroll/, ge = W || te.test(G.overflowX), Ce = W || te.test(G.overflowY), je = ge && y.clientWidth > 0 && y.scrollWidth > y.clientWidth, ht = Ce && y.clientHeight > 0 && y.scrollHeight > y.clientHeight, Be = G.direction === "rtl", vt = ht && (Be ? E.offsetX <= y.offsetWidth - y.clientWidth : E.offsetX > y.clientWidth), Ye = je && E.offsetY > y.clientHeight;
      if (vt || Ye)
        return;
    }
    const M = (N = s.current.floatingContext) == null ? void 0 : N.nodeId, B = g && qe(g.nodesRef.current, M).some((W) => {
      var G;
      return wt(E, (G = W.context) == null ? void 0 : G.elements.floating);
    });
    if (wt(E, r.floating) || wt(E, r.domReference) || B)
      return;
    const Q = g ? qe(g.nodesRef.current, M) : [];
    if (Q.length > 0) {
      let W = !0;
      if (Q.forEach((G) => {
        var te;
        if ((te = G.context) != null && te.open && !G.context.dataRef.current.__outsidePressBubbles) {
          W = !1;
          return;
        }
      }), !W)
        return;
    }
    o(!1, E, "outside-press");
  }), j = ue((E) => {
    var N;
    const $ = () => {
      var P;
      I(E), (P = Ie(E)) == null || P.removeEventListener(l, $);
    };
    (N = Ie(E)) == null || N.addEventListener(l, $);
  });
  x.useEffect(() => {
    if (!n || !i)
      return;
    s.current.__escapeKeyBubbles = v, s.current.__outsidePressBubbles = R;
    let E = -1;
    function N(L) {
      o(!1, L, "ancestor-scroll");
    }
    function $() {
      window.clearTimeout(E), C.current = !0;
    }
    function P() {
      E = window.setTimeout(
        () => {
          C.current = !1;
        },
        // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
        // Only apply to WebKit for the test to remain 0ms.
        br() ? 5 : 0
      );
    }
    const y = Te(r.floating);
    c && (y.addEventListener("keydown", S ? _ : D, S), y.addEventListener("compositionstart", $), y.addEventListener("compositionend", P)), b && y.addEventListener(l, T ? j : I, T);
    let A = [];
    return u && (U(r.domReference) && (A = xe(r.domReference)), U(r.floating) && (A = A.concat(xe(r.floating))), !U(r.reference) && r.reference && r.reference.contextElement && (A = A.concat(xe(r.reference.contextElement)))), A = A.filter((L) => {
      var V;
      return L !== ((V = y.defaultView) == null ? void 0 : V.visualViewport);
    }), A.forEach((L) => {
      L.addEventListener("scroll", N, {
        passive: !0
      });
    }), () => {
      c && (y.removeEventListener("keydown", S ? _ : D, S), y.removeEventListener("compositionstart", $), y.removeEventListener("compositionend", P)), b && y.removeEventListener(l, T ? j : I, T), A.forEach((L) => {
        L.removeEventListener("scroll", N);
      }), window.clearTimeout(E);
    };
  }, [s, r, c, b, l, n, o, u, i, v, R, D, S, _, I, T, j]), x.useEffect(() => {
    s.current.insideReactTree = !1;
  }, [s, b, l]);
  const k = x.useMemo(() => ({
    onKeyDown: D,
    ...f && {
      [ei[p]]: (E) => {
        o(!1, E.nativeEvent, "reference-press");
      },
      ...p !== "click" && {
        onClick(E) {
          o(!1, E.nativeEvent, "reference-press");
        }
      }
    }
  }), [D, o, f, p]), F = x.useMemo(() => ({
    onKeyDown: D,
    onMouseDown() {
      w.current = !0;
    },
    onMouseUp() {
      w.current = !0;
    },
    [ti[l]]: () => {
      s.current.insideReactTree = !0;
    }
  }), [D, l, s]);
  return x.useMemo(() => i ? {
    reference: k,
    floating: F
  } : {}, [i, k, F]);
}
function ni(e) {
  const {
    open: t = !1,
    onOpenChange: n,
    elements: o
  } = e, r = vo(), s = x.useRef({}), [i] = x.useState(() => qs()), c = Gt() != null;
  if (process.env.NODE_ENV !== "production") {
    const d = o.reference;
    d && !U(d) && Us("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
  }
  const [a, l] = x.useState(o.reference), f = ue((d, m, g) => {
    s.current.openEvent = d ? m : void 0, i.emit("openchange", {
      open: d,
      event: m,
      reason: g,
      nested: c
    }), n?.(d, m, g);
  }), p = x.useMemo(() => ({
    setPositionReference: l
  }), []), u = x.useMemo(() => ({
    reference: a || o.reference || null,
    floating: o.floating || null,
    domReference: o.reference
  }), [a, o.reference, o.floating]);
  return x.useMemo(() => ({
    dataRef: s,
    open: t,
    onOpenChange: f,
    elements: u,
    events: i,
    floatingId: r,
    refs: p
  }), [t, f, u, i, r, p]);
}
function oi(e) {
  e === void 0 && (e = {});
  const {
    nodeId: t
  } = e, n = ni({
    ...e,
    elements: {
      reference: null,
      floating: null,
      ...e.elements
    }
  }), o = e.rootContext || n, r = o.elements, [s, i] = x.useState(null), [c, a] = x.useState(null), f = r?.domReference || s, p = x.useRef(null), u = Yt();
  fe(() => {
    f && (p.current = f);
  }, [f]);
  const d = Fs({
    ...e,
    elements: {
      ...r,
      ...c && {
        reference: c
      }
    }
  }), m = x.useCallback((v) => {
    const R = U(v) ? {
      getBoundingClientRect: () => v.getBoundingClientRect(),
      getClientRects: () => v.getClientRects(),
      contextElement: v
    } : v;
    a(R), d.refs.setReference(R);
  }, [d.refs]), g = x.useCallback((v) => {
    (U(v) || v === null) && (p.current = v, i(v)), (U(d.refs.reference.current) || d.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    v !== null && !U(v)) && d.refs.setReference(v);
  }, [d.refs]), h = x.useMemo(() => ({
    ...d.refs,
    setReference: g,
    setPositionReference: m,
    domReference: p
  }), [d.refs, g, m]), b = x.useMemo(() => ({
    ...d.elements,
    domReference: f
  }), [d.elements, f]), w = x.useMemo(() => ({
    ...d,
    ...o,
    refs: h,
    elements: b,
    nodeId: t
  }), [d, h, b, t, o]);
  return fe(() => {
    o.dataRef.current.floatingContext = w;
    const v = u?.nodesRef.current.find((R) => R.id === t);
    v && (v.context = w);
  }), x.useMemo(() => ({
    ...d,
    context: w,
    refs: h,
    elements: b
  }), [d, h, b, w]);
}
function Ct() {
  return Tr() && Pr();
}
function tc(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: o,
    events: r,
    dataRef: s,
    elements: i
  } = e, {
    enabled: c = !0,
    visibleOnly: a = !0
  } = t, l = x.useRef(!1), f = x.useRef(-1), p = x.useRef(!0);
  x.useEffect(() => {
    if (!c) return;
    const d = Le(i.domReference);
    function m() {
      !n && Ft(i.domReference) && i.domReference === un(Te(i.domReference)) && (l.current = !0);
    }
    function g() {
      p.current = !0;
    }
    function h() {
      p.current = !1;
    }
    return d.addEventListener("blur", m), Ct() && (d.addEventListener("keydown", g, !0), d.addEventListener("pointerdown", h, !0)), () => {
      d.removeEventListener("blur", m), Ct() && (d.removeEventListener("keydown", g, !0), d.removeEventListener("pointerdown", h, !0));
    };
  }, [i.domReference, n, c]), x.useEffect(() => {
    if (!c) return;
    function d(m) {
      let {
        reason: g
      } = m;
      (g === "reference-press" || g === "escape-key") && (l.current = !0);
    }
    return r.on("openchange", d), () => {
      r.off("openchange", d);
    };
  }, [r, c]), x.useEffect(() => () => {
    ne(f);
  }, []);
  const u = x.useMemo(() => ({
    onMouseLeave() {
      l.current = !1;
    },
    onFocus(d) {
      if (l.current) return;
      const m = Ie(d.nativeEvent);
      if (a && U(m)) {
        if (Ct() && !d.relatedTarget) {
          if (!p.current && !Dr(m))
            return;
        } else if (!Nr(m))
          return;
      }
      o(!0, d.nativeEvent, "focus");
    },
    onBlur(d) {
      l.current = !1;
      const m = d.relatedTarget, g = d.nativeEvent, h = U(m) && m.hasAttribute(Xt("focus-guard")) && m.getAttribute("data-type") === "outside";
      f.current = window.setTimeout(() => {
        var b;
        const w = un(i.domReference ? i.domReference.ownerDocument : document);
        !m && w === i.domReference || ze((b = s.current.floatingContext) == null ? void 0 : b.refs.floating.current, w) || ze(i.domReference, w) || h || o(!1, g, "focus");
      });
    }
  }), [s, i.domReference, o, a]);
  return x.useMemo(() => c ? {
    reference: u
  } : {}, [c, u]);
}
function St(e, t, n) {
  const o = /* @__PURE__ */ new Map(), r = n === "item";
  let s = e;
  if (r && e) {
    const {
      [Pn]: i,
      [Tn]: c,
      ...a
    } = e;
    s = a;
  }
  return {
    ...n === "floating" && {
      tabIndex: -1,
      [Hs]: ""
    },
    ...s,
    ...t.map((i) => {
      const c = i ? i[n] : null;
      return typeof c == "function" ? e ? c(e) : null : c;
    }).concat(e).reduce((i, c) => (c && Object.entries(c).forEach((a) => {
      let [l, f] = a;
      if (!(r && [Pn, Tn].includes(l)))
        if (l.indexOf("on") === 0) {
          if (o.has(l) || o.set(l, []), typeof f == "function") {
            var p;
            (p = o.get(l)) == null || p.push(f), i[l] = function() {
              for (var u, d = arguments.length, m = new Array(d), g = 0; g < d; g++)
                m[g] = arguments[g];
              return (u = o.get(l)) == null ? void 0 : u.map((h) => h(...m)).find((h) => h !== void 0);
            };
          }
        } else
          i[l] = f;
    }), i), {})
  };
}
function nc(e) {
  e === void 0 && (e = []);
  const t = e.map((c) => c?.reference), n = e.map((c) => c?.floating), o = e.map((c) => c?.item), r = x.useCallback(
    (c) => St(c, e, "reference"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  ), s = x.useCallback(
    (c) => St(c, e, "floating"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    n
  ), i = x.useCallback(
    (c) => St(c, e, "item"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    o
  );
  return x.useMemo(() => ({
    getReferenceProps: r,
    getFloatingProps: s,
    getItemProps: i
  }), [r, s, i]);
}
const ri = /* @__PURE__ */ new Map([["select", "listbox"], ["combobox", "listbox"], ["label", !1]]);
function oc(e, t) {
  var n, o;
  t === void 0 && (t = {});
  const {
    open: r,
    elements: s,
    floatingId: i
  } = e, {
    enabled: c = !0,
    role: a = "dialog"
  } = t, l = vo(), f = ((n = s.domReference) == null ? void 0 : n.id) || l, p = x.useMemo(() => {
    var w;
    return ((w = _r(s.floating)) == null ? void 0 : w.id) || i;
  }, [s.floating, i]), u = (o = ri.get(a)) != null ? o : a, m = Gt() != null, g = x.useMemo(() => u === "tooltip" || a === "label" ? {
    ["aria-" + (a === "label" ? "labelledby" : "describedby")]: r ? p : void 0
  } : {
    "aria-expanded": r ? "true" : "false",
    "aria-haspopup": u === "alertdialog" ? "dialog" : u,
    "aria-controls": r ? p : void 0,
    ...u === "listbox" && {
      role: "combobox"
    },
    ...u === "menu" && {
      id: f
    },
    ...u === "menu" && m && {
      role: "menuitem"
    },
    ...a === "select" && {
      "aria-autocomplete": "none"
    },
    ...a === "combobox" && {
      "aria-autocomplete": "list"
    }
  }, [u, p, m, r, f, a]), h = x.useMemo(() => {
    const w = {
      id: p,
      ...u && {
        role: u
      }
    };
    return u === "tooltip" || a === "label" ? w : {
      ...w,
      ...u === "menu" && {
        "aria-labelledby": f
      }
    };
  }, [u, p, f, a]), b = x.useCallback((w) => {
    let {
      active: v,
      selected: R
    } = w;
    const S = {
      role: "option",
      ...v && {
        id: p + "-fui-option"
      }
    };
    switch (a) {
      case "select":
      case "combobox":
        return {
          ...S,
          "aria-selected": R
        };
    }
    return {};
  }, [p, a]);
  return x.useMemo(() => c ? {
    reference: g,
    floating: h,
    item: b
  } : {}, [c, g, h, b]);
}
var wo = { root: "m_515a97f8" };
const Kt = q((e, t) => {
  const n = z("VisuallyHidden", null, e), { classNames: o, className: r, style: s, styles: i, unstyled: c, vars: a, attributes: l, ...f } = n, p = K({
    name: "VisuallyHidden",
    classes: wo,
    props: n,
    className: r,
    style: s,
    classNames: o,
    styles: i,
    unstyled: c,
    attributes: l
  });
  return /* @__PURE__ */ O.jsx(H, { component: "span", ref: t, ...p("root"), ...f });
});
Kt.classes = wo;
Kt.displayName = "@mantine/core/VisuallyHidden";
function Nn(e, t, n, o) {
  return e === "center" || o === "center" ? { top: t } : e === "end" ? { bottom: n } : e === "start" ? { top: n } : {};
}
function _n(e, t, n, o, r) {
  return e === "center" || o === "center" ? { left: t } : e === "end" ? { [r === "ltr" ? "right" : "left"]: n } : e === "start" ? { [r === "ltr" ? "left" : "right"]: n } : {};
}
const si = {
  bottom: "borderTopLeftRadius",
  left: "borderTopRightRadius",
  right: "borderBottomLeftRadius",
  top: "borderBottomRightRadius"
};
function ii({
  position: e,
  arrowSize: t,
  arrowOffset: n,
  arrowRadius: o,
  arrowPosition: r,
  arrowX: s,
  arrowY: i,
  dir: c
}) {
  const [a, l = "center"] = e.split("-"), f = {
    width: t,
    height: t,
    transform: "rotate(45deg)",
    position: "absolute",
    [si[a]]: o
  }, p = -t / 2;
  return a === "left" ? {
    ...f,
    ...Nn(l, i, n, r),
    right: p,
    borderLeftColor: "transparent",
    borderBottomColor: "transparent",
    clipPath: "polygon(100% 0, 0 0, 100% 100%)"
  } : a === "right" ? {
    ...f,
    ...Nn(l, i, n, r),
    left: p,
    borderRightColor: "transparent",
    borderTopColor: "transparent",
    clipPath: "polygon(0 100%, 0 0, 100% 100%)"
  } : a === "top" ? {
    ...f,
    ..._n(l, s, n, r, c),
    bottom: p,
    borderTopColor: "transparent",
    borderLeftColor: "transparent",
    clipPath: "polygon(0 100%, 100% 100%, 100% 0)"
  } : a === "bottom" ? {
    ...f,
    ..._n(l, s, n, r, c),
    top: p,
    borderBottomColor: "transparent",
    borderRightColor: "transparent",
    clipPath: "polygon(0 100%, 0 0, 100% 0)"
  } : {};
}
const bo = Vo(
  ({
    position: e,
    arrowSize: t,
    arrowOffset: n,
    arrowRadius: o,
    arrowPosition: r,
    visible: s,
    arrowX: i,
    arrowY: c,
    style: a,
    ...l
  }, f) => {
    const { dir: p } = Un();
    return s ? /* @__PURE__ */ O.jsx(
      "div",
      {
        ...l,
        ref: f,
        style: {
          ...a,
          ...ii({
            position: e,
            arrowSize: t,
            arrowOffset: n,
            arrowRadius: o,
            arrowPosition: r,
            dir: p,
            arrowX: i,
            arrowY: c
          })
        }
      }
    ) : null;
  }
);
bo.displayName = "@mantine/core/FloatingArrow";
function ci(e, t) {
  if (e === "rtl" && (t.includes("right") || t.includes("left"))) {
    const [n, o] = t.split("-"), r = n === "right" ? "left" : "right";
    return o === void 0 ? r : `${r}-${o}`;
  }
  return t;
}
var xo = { root: "m_9814e45f" };
const ai = {
  zIndex: Yn("modal")
}, li = J(
  (e, { gradient: t, color: n, backgroundOpacity: o, blur: r, radius: s, zIndex: i }) => ({
    root: {
      "--overlay-bg": t || (n !== void 0 || o !== void 0) && Xo(n || "#000", o ?? 0.6) || void 0,
      "--overlay-filter": r ? `blur(${ee(r)})` : void 0,
      "--overlay-radius": s === void 0 ? void 0 : Ae(s),
      "--overlay-z-index": i?.toString()
    }
  })
), Ut = ot((e, t) => {
  const n = z("Overlay", ai, e), {
    classNames: o,
    className: r,
    style: s,
    styles: i,
    unstyled: c,
    vars: a,
    fixed: l,
    center: f,
    children: p,
    radius: u,
    zIndex: d,
    gradient: m,
    blur: g,
    color: h,
    backgroundOpacity: b,
    mod: w,
    attributes: v,
    ...R
  } = n, S = K({
    name: "Overlay",
    props: n,
    classes: xo,
    className: r,
    style: s,
    classNames: o,
    styles: i,
    unstyled: c,
    attributes: v,
    vars: a,
    varsResolver: li
  });
  return /* @__PURE__ */ O.jsx(H, { ref: t, ...S("root"), mod: [{ center: f, fixed: l }, w], ...R, children: p });
});
Ut.classes = xo;
Ut.displayName = "@mantine/core/Overlay";
const We = (e) => ({
  in: { opacity: 1, transform: "scale(1)" },
  out: { opacity: 0, transform: `scale(.9) translateY(${e === "bottom" ? 10 : -10}px)` },
  transitionProperty: "transform, opacity"
}), Ue = {
  fade: {
    in: { opacity: 1 },
    out: { opacity: 0 },
    transitionProperty: "opacity"
  },
  "fade-up": {
    in: { opacity: 1, transform: "translateY(0)" },
    out: { opacity: 0, transform: "translateY(30px)" },
    transitionProperty: "opacity, transform"
  },
  "fade-down": {
    in: { opacity: 1, transform: "translateY(0)" },
    out: { opacity: 0, transform: "translateY(-30px)" },
    transitionProperty: "opacity, transform"
  },
  "fade-left": {
    in: { opacity: 1, transform: "translateX(0)" },
    out: { opacity: 0, transform: "translateX(30px)" },
    transitionProperty: "opacity, transform"
  },
  "fade-right": {
    in: { opacity: 1, transform: "translateX(0)" },
    out: { opacity: 0, transform: "translateX(-30px)" },
    transitionProperty: "opacity, transform"
  },
  scale: {
    in: { opacity: 1, transform: "scale(1)" },
    out: { opacity: 0, transform: "scale(0)" },
    common: { transformOrigin: "top" },
    transitionProperty: "transform, opacity"
  },
  "scale-y": {
    in: { opacity: 1, transform: "scaleY(1)" },
    out: { opacity: 0, transform: "scaleY(0)" },
    common: { transformOrigin: "top" },
    transitionProperty: "transform, opacity"
  },
  "scale-x": {
    in: { opacity: 1, transform: "scaleX(1)" },
    out: { opacity: 0, transform: "scaleX(0)" },
    common: { transformOrigin: "left" },
    transitionProperty: "transform, opacity"
  },
  "skew-up": {
    in: { opacity: 1, transform: "translateY(0) skew(0deg, 0deg)" },
    out: { opacity: 0, transform: "translateY(-20px) skew(-10deg, -5deg)" },
    common: { transformOrigin: "top" },
    transitionProperty: "transform, opacity"
  },
  "skew-down": {
    in: { opacity: 1, transform: "translateY(0) skew(0deg, 0deg)" },
    out: { opacity: 0, transform: "translateY(20px) skew(-10deg, -5deg)" },
    common: { transformOrigin: "bottom" },
    transitionProperty: "transform, opacity"
  },
  "rotate-left": {
    in: { opacity: 1, transform: "translateY(0) rotate(0deg)" },
    out: { opacity: 0, transform: "translateY(20px) rotate(-5deg)" },
    common: { transformOrigin: "bottom" },
    transitionProperty: "transform, opacity"
  },
  "rotate-right": {
    in: { opacity: 1, transform: "translateY(0) rotate(0deg)" },
    out: { opacity: 0, transform: "translateY(20px) rotate(5deg)" },
    common: { transformOrigin: "top" },
    transitionProperty: "transform, opacity"
  },
  "slide-down": {
    in: { opacity: 1, transform: "translateY(0)" },
    out: { opacity: 0, transform: "translateY(-100%)" },
    common: { transformOrigin: "top" },
    transitionProperty: "transform, opacity"
  },
  "slide-up": {
    in: { opacity: 1, transform: "translateY(0)" },
    out: { opacity: 0, transform: "translateY(100%)" },
    common: { transformOrigin: "bottom" },
    transitionProperty: "transform, opacity"
  },
  "slide-left": {
    in: { opacity: 1, transform: "translateX(0)" },
    out: { opacity: 0, transform: "translateX(100%)" },
    common: { transformOrigin: "left" },
    transitionProperty: "transform, opacity"
  },
  "slide-right": {
    in: { opacity: 1, transform: "translateX(0)" },
    out: { opacity: 0, transform: "translateX(-100%)" },
    common: { transformOrigin: "right" },
    transitionProperty: "transform, opacity"
  },
  pop: {
    ...We("bottom"),
    common: { transformOrigin: "center center" }
  },
  "pop-bottom-left": {
    ...We("bottom"),
    common: { transformOrigin: "bottom left" }
  },
  "pop-bottom-right": {
    ...We("bottom"),
    common: { transformOrigin: "bottom right" }
  },
  "pop-top-left": {
    ...We("top"),
    common: { transformOrigin: "top left" }
  },
  "pop-top-right": {
    ...We("top"),
    common: { transformOrigin: "top right" }
  }
}, Ln = {
  entering: "in",
  entered: "in",
  exiting: "out",
  exited: "out",
  "pre-exiting": "out",
  "pre-entering": "out"
};
function ui({
  transition: e,
  state: t,
  duration: n,
  timingFunction: o
}) {
  const r = {
    WebkitBackfaceVisibility: "hidden",
    transitionDuration: `${n}ms`,
    transitionTimingFunction: o
  };
  return typeof e == "string" ? e in Ue ? {
    transitionProperty: Ue[e].transitionProperty,
    ...r,
    ...Ue[e].common,
    ...Ue[e][Ln[t]]
  } : {} : {
    transitionProperty: e.transitionProperty,
    ...r,
    ...e.common,
    ...e[Ln[t]]
  };
}
function fi({
  duration: e,
  exitDuration: t,
  timingFunction: n,
  mounted: o,
  onEnter: r,
  onExit: s,
  onEntered: i,
  onExited: c,
  enterDelay: a,
  exitDelay: l
}) {
  const f = zn(), p = Qo(), u = f.respectReducedMotion ? p : !1, [d, m] = be(u ? 0 : e), [g, h] = be(o ? "entered" : "exited"), b = he(-1), w = he(-1), v = he(-1);
  function R() {
    window.clearTimeout(b.current), window.clearTimeout(w.current), cancelAnimationFrame(v.current);
  }
  const S = (C) => {
    R();
    const D = C ? r : s, _ = C ? i : c, I = u ? 0 : C ? e : t;
    m(I), I === 0 ? (typeof D == "function" && D(), typeof _ == "function" && _(), h(C ? "entered" : "exited")) : v.current = requestAnimationFrame(() => {
      nr.flushSync(() => {
        h(C ? "pre-entering" : "pre-exiting");
      }), v.current = requestAnimationFrame(() => {
        typeof D == "function" && D(), h(C ? "entering" : "exiting"), b.current = window.setTimeout(() => {
          typeof _ == "function" && _(), h(C ? "entered" : "exited");
        }, I);
      });
    });
  }, T = (C) => {
    if (R(), typeof (C ? a : l) != "number") {
      S(C);
      return;
    }
    w.current = window.setTimeout(
      () => {
        S(C);
      },
      C ? a : l
    );
  };
  return Ze(() => {
    T(o);
  }, [o]), Ve(
    () => () => {
      R();
    },
    []
  ), {
    transitionDuration: d,
    transitionStatus: g,
    transitionTimingFunction: n || "ease"
  };
}
function Ge({
  keepMounted: e,
  transition: t = "fade",
  duration: n = 250,
  exitDuration: o = n,
  mounted: r,
  children: s,
  timingFunction: i = "ease",
  onExit: c,
  onEntered: a,
  onEnter: l,
  onExited: f,
  enterDelay: p,
  exitDelay: u
}) {
  const d = $t(), { transitionDuration: m, transitionStatus: g, transitionTimingFunction: h } = fi({
    mounted: r,
    exitDuration: o,
    duration: n,
    timingFunction: i,
    onExit: c,
    onEntered: a,
    onEnter: l,
    onExited: f,
    enterDelay: p,
    exitDelay: u
  });
  return m === 0 || d === "test" ? r ? /* @__PURE__ */ O.jsx(O.Fragment, { children: s({}) }) : e ? s({ display: "none" }) : null : g === "exited" ? e ? s({ display: "none" }) : null : /* @__PURE__ */ O.jsx(O.Fragment, { children: s(
    ui({
      transition: t,
      duration: m,
      state: g,
      timingFunction: h
    })
  ) });
}
Ge.displayName = "@mantine/core/Transition";
const [di, Ro] = er(
  "Popover component was not found in the tree"
);
var Eo = { dropdown: "m_38a85659", arrow: "m_a31dc6c1", overlay: "m_3d7bc908" };
function qt({
  children: e,
  active: t = !0,
  refProp: n = "ref",
  innerRef: o
}) {
  const r = mr(t), s = Mt(r, o), i = to(e);
  return i ? Wn(i, { [n]: s }) : e;
}
function Co(e) {
  return /* @__PURE__ */ O.jsx(Kt, { tabIndex: -1, "data-autofocus": !0, ...e });
}
qt.displayName = "@mantine/core/FocusTrap";
Co.displayName = "@mantine/core/FocusTrapInitialFocus";
qt.InitialFocus = Co;
const Jt = q((e, t) => {
  const n = z("PopoverDropdown", null, e), {
    className: o,
    style: r,
    vars: s,
    children: i,
    onKeyDownCapture: c,
    variant: a,
    classNames: l,
    styles: f,
    ...p
  } = n, u = Ro(), d = ar({
    opened: u.opened,
    shouldReturnFocus: u.returnFocus
  }), m = u.withRoles ? {
    "aria-labelledby": u.getTargetId(),
    id: u.getDropdownId(),
    role: "dialog",
    tabIndex: -1
  } : {}, g = Mt(t, u.floating);
  return u.disabled ? null : /* @__PURE__ */ O.jsx(Xn, { ...u.portalProps, withinPortal: u.withinPortal, children: /* @__PURE__ */ O.jsx(
    Ge,
    {
      mounted: u.opened,
      ...u.transitionProps,
      transition: u.transitionProps?.transition || "fade",
      duration: u.transitionProps?.duration ?? 150,
      keepMounted: u.keepMounted,
      exitDuration: typeof u.transitionProps?.exitDuration == "number" ? u.transitionProps.exitDuration : u.transitionProps?.duration,
      children: (h) => /* @__PURE__ */ O.jsx(qt, { active: u.trapFocus && u.opened, innerRef: g, children: /* @__PURE__ */ O.jsxs(
        H,
        {
          ...m,
          ...p,
          variant: a,
          onKeyDownCapture: sr(
            () => {
              u.onClose?.(), u.onDismiss?.();
            },
            {
              active: u.closeOnEscape,
              onTrigger: d,
              onKeyDown: c
            }
          ),
          "data-position": u.placement,
          "data-fixed": u.floatingStrategy === "fixed" || void 0,
          ...u.getStyles("dropdown", {
            className: o,
            props: n,
            classNames: l,
            styles: f,
            style: [
              {
                ...h,
                zIndex: u.zIndex,
                top: u.y ?? 0,
                left: u.x ?? 0,
                width: u.width === "target" ? void 0 : ee(u.width),
                ...u.referenceHidden ? { display: "none" } : null
              },
              u.resolvedStyles.dropdown,
              f?.dropdown,
              r
            ]
          }),
          children: [
            i,
            /* @__PURE__ */ O.jsx(
              bo,
              {
                ref: u.arrowRef,
                arrowX: u.arrowX,
                arrowY: u.arrowY,
                visible: u.withArrow,
                position: u.placement,
                arrowSize: u.arrowSize,
                arrowRadius: u.arrowRadius,
                arrowOffset: u.arrowOffset,
                arrowPosition: u.arrowPosition,
                ...u.getStyles("arrow", {
                  props: n,
                  classNames: l,
                  styles: f
                })
              }
            )
          ]
        }
      ) })
    }
  ) });
});
Jt.classes = Eo;
Jt.displayName = "@mantine/core/PopoverDropdown";
const pi = {
  refProp: "ref",
  popupType: "dialog"
}, So = q((e, t) => {
  const { children: n, refProp: o, popupType: r, ...s } = z(
    "PopoverTarget",
    pi,
    e
  ), i = to(n);
  if (!i)
    throw new Error(
      "Popover.Target component children should be an element or a component that accepts ref. Fragments, strings, numbers and other primitive values are not supported"
    );
  const c = s, a = Ro(), l = Mt(a.reference, yr(i), t), f = a.withRoles ? {
    "aria-haspopup": r,
    "aria-expanded": a.opened,
    "aria-controls": a.opened ? a.getDropdownId() : void 0,
    id: a.getTargetId()
  } : {}, p = i.props;
  return Wn(i, {
    ...c,
    ...f,
    ...a.targetProps,
    className: Ko(a.targetProps.className, c.className, p.className),
    [o]: l,
    ...a.controlled ? null : {
      onClick: () => {
        a.onToggle(), p.onClick?.();
      }
    }
  });
});
So.displayName = "@mantine/core/PopoverTarget";
function mi(e) {
  if (e === void 0)
    return { shift: !0, flip: !0 };
  const t = { ...e };
  return e.shift === void 0 && (t.shift = !0), e.flip === void 0 && (t.flip = !0), t;
}
function gi(e, t, n) {
  const o = mi(e.middlewares), r = [js(e.offset), zs()];
  return e.dropdownVisible && n !== "test" && e.preventPositionChangeWhenVisible && (o.flip = !1), o.flip && r.push(
    typeof o.flip == "boolean" ? Cn() : Cn(o.flip)
  ), o.shift && r.push(
    Bs(
      typeof o.shift == "boolean" ? { limiter: En(), padding: 5 } : { limiter: En(), padding: 5, ...o.shift }
    )
  ), o.inline && r.push(
    typeof o.inline == "boolean" ? Sn() : Sn(o.inline)
  ), r.push(Vs({ element: e.arrowRef, padding: e.arrowOffset })), (o.size || e.width === "target") && r.push(
    Ws({
      ...typeof o.size == "boolean" ? {} : o.size,
      apply({ rects: s, availableWidth: i, availableHeight: c, ...a }) {
        const f = t().refs.floating.current?.style ?? {};
        o.size && (typeof o.size == "object" && o.size.apply ? o.size.apply({ rects: s, availableWidth: i, availableHeight: c, ...a }) : Object.assign(f, {
          maxWidth: `${i}px`,
          maxHeight: `${c}px`
        })), e.width === "target" && Object.assign(f, {
          width: `${s.reference.width}px`
        });
      }
    })
  ), r;
}
function hi(e) {
  const t = $t(), [n, o] = vr({
    value: e.opened,
    defaultValue: e.defaultOpened,
    finalValue: !1,
    onChange: e.onChange
  }), r = he(n), s = () => {
    n && !e.disabled && o(!1);
  }, i = () => {
    e.disabled || o(!n);
  }, c = oi({
    strategy: e.strategy,
    placement: e.preventPositionChangeWhenVisible ? e.positionRef.current : e.position,
    middleware: gi(e, () => c, t),
    whileElementsMounted: e.keepMounted ? void 0 : bn
  });
  return Ve(() => {
    if (!(!c.refs.reference.current || !c.refs.floating.current) && n)
      return bn(
        c.refs.reference.current,
        c.refs.floating.current,
        c.update
      );
  }, [n, c.update]), Ze(() => {
    e.onPositionChange?.(c.placement), e.positionRef.current = c.placement;
  }, [c.placement, e.preventPositionChangeWhenVisible]), Ze(() => {
    n !== r.current && (n ? e.onOpen?.() : e.onClose?.()), r.current = n;
  }, [n, e.onClose, e.onOpen]), Gn(() => {
    let a = -1;
    return n && (a = window.setTimeout(() => e.setDropdownVisible(!0), 4)), () => {
      window.clearTimeout(a);
    };
  }, [n, e.position]), {
    floating: c,
    controlled: typeof e.opened == "boolean",
    opened: n,
    onClose: s,
    onToggle: i
  };
}
const vi = {
  position: "bottom",
  offset: 8,
  positionDependencies: [],
  transitionProps: { transition: "fade", duration: 150 },
  middlewares: { flip: !0, shift: !0, inline: !1 },
  arrowSize: 7,
  arrowOffset: 5,
  arrowRadius: 0,
  arrowPosition: "side",
  closeOnClickOutside: !0,
  withinPortal: !0,
  closeOnEscape: !0,
  trapFocus: !1,
  withRoles: !0,
  returnFocus: !1,
  withOverlay: !1,
  hideDetached: !0,
  clickOutsideEvents: ["mousedown", "touchstart"],
  zIndex: Yn("popover"),
  __staticSelector: "Popover",
  width: "max-content"
}, yi = J((e, { radius: t, shadow: n }) => ({
  dropdown: {
    "--popover-radius": t === void 0 ? void 0 : Ae(t),
    "--popover-shadow": Uo(n)
  }
}));
function lt(e) {
  const t = z("Popover", vi, e), {
    children: n,
    position: o,
    offset: r,
    onPositionChange: s,
    // Scheduled for removal in 9.0
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    positionDependencies: i,
    opened: c,
    transitionProps: a,
    onExitTransitionEnd: l,
    onEnterTransitionEnd: f,
    width: p,
    middlewares: u,
    withArrow: d,
    arrowSize: m,
    arrowOffset: g,
    arrowRadius: h,
    arrowPosition: b,
    unstyled: w,
    classNames: v,
    styles: R,
    closeOnClickOutside: S,
    withinPortal: T,
    portalProps: C,
    closeOnEscape: D,
    clickOutsideEvents: _,
    trapFocus: I,
    onClose: j,
    onDismiss: k,
    onOpen: F,
    onChange: E,
    zIndex: N,
    radius: $,
    shadow: P,
    id: y,
    defaultOpened: A,
    __staticSelector: L,
    withRoles: V,
    disabled: M,
    returnFocus: B,
    variant: Q,
    keepMounted: W,
    vars: G,
    floatingStrategy: te,
    withOverlay: ge,
    overlayProps: Ce,
    hideDetached: je,
    attributes: ht,
    preventPositionChangeWhenVisible: Be,
    ...vt
  } = t, Ye = K({
    name: L,
    props: t,
    classes: Eo,
    classNames: v,
    styles: R,
    unstyled: w,
    attributes: ht,
    rootSelector: "dropdown",
    vars: G,
    varsResolver: yi
  }), { resolvedStyles: Ao } = no({ classNames: v, styles: R, props: t }), [Io, rn] = be(c ?? A ?? !1), sn = he(o), cn = he(null), [Do, No] = be(null), [_o, Lo] = be(null), { dir: $o } = Un(), Mo = $t(), an = eo(y), Y = hi({
    middlewares: u,
    width: p,
    position: ci($o, o),
    offset: typeof r == "number" ? r + (d ? m / 2 : 0) : r,
    arrowRef: cn,
    arrowOffset: g,
    onPositionChange: s,
    positionDependencies: i,
    opened: c,
    defaultOpened: A,
    onChange: E,
    onOpen: F,
    onClose: j,
    onDismiss: k,
    strategy: te,
    dropdownVisible: Io,
    setDropdownVisible: rn,
    positionRef: sn,
    disabled: M,
    preventPositionChangeWhenVisible: Be,
    keepMounted: W
  });
  cr(
    () => {
      S && (Y.onClose(), k?.());
    },
    _,
    [Do, _o]
  );
  const Fo = we(
    (Se) => {
      No(Se), Y.floating.refs.setReference(Se);
    },
    [Y.floating.refs.setReference]
  ), ko = we(
    (Se) => {
      Lo(Se), Y.floating.refs.setFloating(Se);
    },
    [Y.floating.refs.setFloating]
  ), jo = we(() => {
    a?.onExited?.(), l?.(), rn(!1), Be || (sn.current = o);
  }, [a?.onExited, l, Be, o]), Bo = we(() => {
    a?.onEntered?.(), f?.();
  }, [a?.onEntered, f]);
  return /* @__PURE__ */ O.jsxs(
    di,
    {
      value: {
        returnFocus: B,
        disabled: M,
        controlled: Y.controlled,
        reference: Fo,
        floating: ko,
        x: Y.floating.x,
        y: Y.floating.y,
        arrowX: Y.floating?.middlewareData?.arrow?.x,
        arrowY: Y.floating?.middlewareData?.arrow?.y,
        opened: Y.opened,
        arrowRef: cn,
        transitionProps: { ...a, onExited: jo, onEntered: Bo },
        width: p,
        withArrow: d,
        arrowSize: m,
        arrowOffset: g,
        arrowRadius: h,
        arrowPosition: b,
        placement: Y.floating.placement,
        trapFocus: I,
        withinPortal: T,
        portalProps: C,
        zIndex: N,
        radius: $,
        shadow: P,
        closeOnEscape: D,
        onDismiss: k,
        onClose: Y.onClose,
        onToggle: Y.onToggle,
        getTargetId: () => `${an}-target`,
        getDropdownId: () => `${an}-dropdown`,
        withRoles: V,
        targetProps: vt,
        __staticSelector: L,
        classNames: v,
        styles: R,
        unstyled: w,
        variant: Q,
        keepMounted: W,
        getStyles: Ye,
        resolvedStyles: Ao,
        floatingStrategy: te,
        referenceHidden: je && Mo !== "test" ? Y.floating.middlewareData.hide?.referenceHidden : !1
      },
      children: [
        n,
        ge && /* @__PURE__ */ O.jsx(
          Ge,
          {
            transition: "fade",
            mounted: Y.opened,
            duration: a?.duration || 250,
            exitDuration: a?.exitDuration || 250,
            children: (Se) => /* @__PURE__ */ O.jsx(Xn, { withinPortal: T, children: /* @__PURE__ */ O.jsx(
              Ut,
              {
                ...Ce,
                ...Ye("overlay", {
                  className: Ce?.className,
                  style: [Se, Ce?.style]
                })
              }
            ) })
          }
        )
      ]
    }
  );
}
lt.Target = So;
lt.Dropdown = Jt;
lt.displayName = "@mantine/core/Popover";
lt.extend = (e) => e;
var Fe = { root: "m_8d3f4000", icon: "m_8d3afb97", loader: "m_302b9fb1", group: "m_1a0f1b21", groupSection: "m_437b6484" };
const $n = {
  orientation: "horizontal"
}, wi = J((e, { borderWidth: t }) => ({
  group: { "--ai-border-width": ee(t) }
})), Qt = q((e, t) => {
  const n = z("ActionIconGroup", $n, e), {
    className: o,
    style: r,
    classNames: s,
    styles: i,
    unstyled: c,
    orientation: a,
    vars: l,
    borderWidth: f,
    variant: p,
    mod: u,
    attributes: d,
    ...m
  } = z("ActionIconGroup", $n, e), g = K({
    name: "ActionIconGroup",
    props: n,
    classes: Fe,
    className: o,
    style: r,
    classNames: s,
    styles: i,
    unstyled: c,
    attributes: d,
    vars: l,
    varsResolver: wi,
    rootSelector: "group"
  });
  return /* @__PURE__ */ O.jsx(
    H,
    {
      ...g("group"),
      ref: t,
      variant: p,
      mod: [{ "data-orientation": a }, u],
      role: "group",
      ...m
    }
  );
});
Qt.classes = Fe;
Qt.displayName = "@mantine/core/ActionIconGroup";
const bi = J(
  (e, { radius: t, color: n, gradient: o, variant: r, autoContrast: s, size: i }) => {
    const c = e.variantColorResolver({
      color: n || e.primaryColor,
      theme: e,
      gradient: o,
      variant: r || "filled",
      autoContrast: s
    });
    return {
      groupSection: {
        "--section-height": ve(i, "section-height"),
        "--section-padding-x": ve(i, "section-padding-x"),
        "--section-fz": oe(i),
        "--section-radius": t === void 0 ? void 0 : Ae(t),
        "--section-bg": n || r ? c.background : void 0,
        "--section-color": c.color,
        "--section-bd": n || r ? c.border : void 0
      }
    };
  }
), Zt = q((e, t) => {
  const n = z("ActionIconGroupSection", null, e), {
    className: o,
    style: r,
    classNames: s,
    styles: i,
    unstyled: c,
    vars: a,
    variant: l,
    gradient: f,
    radius: p,
    autoContrast: u,
    attributes: d,
    ...m
  } = n, g = K({
    name: "ActionIconGroupSection",
    props: n,
    classes: Fe,
    className: o,
    style: r,
    classNames: s,
    styles: i,
    unstyled: c,
    attributes: d,
    vars: a,
    varsResolver: bi,
    rootSelector: "groupSection"
  });
  return /* @__PURE__ */ O.jsx(H, { ...g("groupSection"), ref: t, variant: l, ...m });
});
Zt.classes = Fe;
Zt.displayName = "@mantine/core/ActionIconGroupSection";
const xi = J(
  (e, { size: t, radius: n, variant: o, gradient: r, color: s, autoContrast: i }) => {
    const c = e.variantColorResolver({
      color: s || e.primaryColor,
      theme: e,
      gradient: r,
      variant: o || "filled",
      autoContrast: i
    });
    return {
      root: {
        "--ai-size": ve(t, "ai-size"),
        "--ai-radius": n === void 0 ? void 0 : Ae(n),
        "--ai-bg": s || o ? c.background : void 0,
        "--ai-hover": s || o ? c.hover : void 0,
        "--ai-hover-color": s || o ? c.hoverColor : void 0,
        "--ai-color": c.color,
        "--ai-bd": s || o ? c.border : void 0
      }
    };
  }
), ut = ot((e, t) => {
  const n = z("ActionIcon", null, e), {
    className: o,
    unstyled: r,
    variant: s,
    classNames: i,
    styles: c,
    style: a,
    loading: l,
    loaderProps: f,
    size: p,
    color: u,
    radius: d,
    __staticSelector: m,
    gradient: g,
    vars: h,
    children: b,
    disabled: w,
    "data-disabled": v,
    autoContrast: R,
    mod: S,
    attributes: T,
    ...C
  } = n, D = K({
    name: ["ActionIcon", m],
    props: n,
    className: o,
    style: a,
    classes: Fe,
    classNames: i,
    styles: c,
    unstyled: r,
    attributes: T,
    vars: h,
    varsResolver: xi
  });
  return /* @__PURE__ */ O.jsxs(
    Vn,
    {
      ...D("root", { active: !w && !l && !v }),
      ...C,
      unstyled: r,
      variant: s,
      size: p,
      disabled: w || l,
      ref: t,
      mod: [{ loading: l, disabled: w || v }, S],
      children: [
        typeof l == "boolean" && /* @__PURE__ */ O.jsx(Ge, { mounted: l, transition: "slide-down", duration: 150, children: (_) => /* @__PURE__ */ O.jsx(H, { component: "span", ...D("loader", { style: _ }), "aria-hidden": !0, children: /* @__PURE__ */ O.jsx(Kn, { color: "var(--ai-color)", size: "calc(var(--ai-size) * 0.55)", ...f }) }) }),
        /* @__PURE__ */ O.jsx(H, { component: "span", mod: { loading: l }, ...D("icon"), children: b })
      ]
    }
  );
});
ut.classes = Fe;
ut.displayName = "@mantine/core/ActionIcon";
ut.Group = Qt;
ut.GroupSection = Zt;
function Ri(e) {
  return jn.toArray(e).filter(Boolean);
}
var Po = { root: "m_4081bf90" };
const Ei = {
  preventGrowOverflow: !0,
  gap: "md",
  align: "center",
  justify: "flex-start",
  wrap: "wrap"
}, Ci = J(
  (e, { grow: t, preventGrowOverflow: n, gap: o, align: r, justify: s, wrap: i }, { childWidth: c }) => ({
    root: {
      "--group-child-width": t && n ? c : void 0,
      "--group-gap": Hn(o),
      "--group-align": r,
      "--group-justify": s,
      "--group-wrap": i
    }
  })
), To = q((e, t) => {
  const n = z("Group", Ei, e), {
    classNames: o,
    className: r,
    style: s,
    styles: i,
    unstyled: c,
    children: a,
    gap: l,
    align: f,
    justify: p,
    wrap: u,
    grow: d,
    preventGrowOverflow: m,
    vars: g,
    variant: h,
    __size: b,
    mod: w,
    attributes: v,
    ...R
  } = n, S = Ri(a), T = S.length, C = Hn(l ?? "md"), _ = { childWidth: `calc(${100 / T}% - (${C} - ${C} / ${T}))` }, I = K({
    name: "Group",
    props: n,
    stylesCtx: _,
    className: r,
    style: s,
    classes: Po,
    classNames: o,
    styles: i,
    unstyled: c,
    attributes: v,
    vars: g,
    varsResolver: Ci
  });
  return /* @__PURE__ */ O.jsx(
    H,
    {
      ...I("root"),
      ref: t,
      variant: h,
      mod: [{ grow: d }, w],
      size: b,
      ...R,
      children: S
    }
  );
});
To.classes = Po;
To.displayName = "@mantine/core/Group";
const [Si, Pi] = qn({
  size: "sm"
});
var re = { wrapper: "m_6c018570", input: "m_8fb7ebe7", section: "m_82577fc2", placeholder: "m_88bacfd0", root: "m_46b77525", label: "m_8fdc1311", required: "m_78a94662", error: "m_8f816625", description: "m_fe47ce59" };
const Oo = q((e, t) => {
  const n = z("InputClearButton", null, e), { size: o, variant: r, vars: s, classNames: i, styles: c, ...a } = n, l = Pi(), { resolvedClassNames: f, resolvedStyles: p } = no({
    classNames: i,
    styles: c,
    props: n
  });
  return /* @__PURE__ */ O.jsx(
    Zo,
    {
      variant: r || "transparent",
      ref: t,
      size: o || l?.size || "sm",
      classNames: f,
      styles: p,
      __staticSelector: "InputClearButton",
      style: { pointerEvents: "all", background: "var(--input-bg)", ...a.style },
      ...a
    }
  );
});
Oo.displayName = "@mantine/core/InputClearButton";
const Ti = {
  xs: 7,
  sm: 8,
  md: 10,
  lg: 12,
  xl: 15
};
function Oi({
  __clearable: e,
  __clearSection: t,
  rightSection: n,
  __defaultRightSection: o,
  size: r = "sm"
}) {
  const s = e && t;
  return s && (n || o) ? /* @__PURE__ */ O.jsxs(
    "div",
    {
      "data-combined-clear-section": !0,
      style: {
        display: "flex",
        gap: 2,
        alignItems: "center",
        paddingInlineEnd: Ti[r]
      },
      children: [
        s,
        n || o
      ]
    }
  ) : n === null ? null : n || s || o;
}
const [Ai, ft] = qn({
  offsetBottom: !1,
  offsetTop: !1,
  describedBy: void 0,
  getStyles: null,
  inputId: void 0,
  labelId: void 0
}), Ii = J((e, { size: t }) => ({
  description: {
    "--input-description-size": t === void 0 ? void 0 : `calc(${oe(t)} - ${ee(2)})`
  }
})), dt = q((e, t) => {
  const n = z("InputDescription", null, e), {
    classNames: o,
    className: r,
    style: s,
    styles: i,
    unstyled: c,
    vars: a,
    size: l,
    __staticSelector: f,
    __inheritStyles: p = !0,
    attributes: u,
    variant: d,
    ...m
  } = z("InputDescription", null, n), g = ft(), h = K({
    name: ["InputWrapper", f],
    props: n,
    classes: re,
    className: r,
    style: s,
    classNames: o,
    styles: i,
    unstyled: c,
    attributes: u,
    rootSelector: "description",
    vars: a,
    varsResolver: Ii
  }), b = p && g?.getStyles || h;
  return /* @__PURE__ */ O.jsx(
    H,
    {
      component: "p",
      ref: t,
      variant: d,
      size: l,
      ...b("description", g?.getStyles ? { className: r, style: s } : void 0),
      ...m
    }
  );
});
dt.classes = re;
dt.displayName = "@mantine/core/InputDescription";
const Di = J((e, { size: t }) => ({
  error: {
    "--input-error-size": t === void 0 ? void 0 : `calc(${oe(t)} - ${ee(2)})`
  }
})), pt = q((e, t) => {
  const n = z("InputError", null, e), {
    classNames: o,
    className: r,
    style: s,
    styles: i,
    unstyled: c,
    vars: a,
    size: l,
    attributes: f,
    __staticSelector: p,
    __inheritStyles: u = !0,
    variant: d,
    ...m
  } = n, g = K({
    name: ["InputWrapper", p],
    props: n,
    classes: re,
    className: r,
    style: s,
    classNames: o,
    styles: i,
    unstyled: c,
    attributes: f,
    rootSelector: "error",
    vars: a,
    varsResolver: Di
  }), h = ft(), b = u && h?.getStyles || g;
  return /* @__PURE__ */ O.jsx(
    H,
    {
      component: "p",
      ref: t,
      variant: d,
      size: l,
      ...b("error", h?.getStyles ? { className: r, style: s } : void 0),
      ...m
    }
  );
});
pt.classes = re;
pt.displayName = "@mantine/core/InputError";
const Mn = {
  labelElement: "label"
}, Ni = J((e, { size: t }) => ({
  label: {
    "--input-label-size": oe(t),
    "--input-asterisk-color": void 0
  }
})), mt = q((e, t) => {
  const n = z("InputLabel", Mn, e), {
    classNames: o,
    className: r,
    style: s,
    styles: i,
    unstyled: c,
    vars: a,
    labelElement: l,
    size: f,
    required: p,
    htmlFor: u,
    onMouseDown: d,
    children: m,
    __staticSelector: g,
    variant: h,
    mod: b,
    attributes: w,
    ...v
  } = z("InputLabel", Mn, n), R = K({
    name: ["InputWrapper", g],
    props: n,
    classes: re,
    className: r,
    style: s,
    classNames: o,
    styles: i,
    unstyled: c,
    attributes: w,
    rootSelector: "label",
    vars: a,
    varsResolver: Ni
  }), S = ft(), T = S?.getStyles || R;
  return /* @__PURE__ */ O.jsxs(
    H,
    {
      ...T("label", S?.getStyles ? { className: r, style: s } : void 0),
      component: l,
      variant: h,
      size: f,
      ref: t,
      htmlFor: l === "label" ? u : void 0,
      mod: [{ required: p }, b],
      onMouseDown: (C) => {
        d?.(C), !C.defaultPrevented && C.detail > 1 && C.preventDefault();
      },
      ...v,
      children: [
        m,
        p && /* @__PURE__ */ O.jsx("span", { ...T("required"), "aria-hidden": !0, children: " *" })
      ]
    }
  );
});
mt.classes = re;
mt.displayName = "@mantine/core/InputLabel";
const en = q((e, t) => {
  const n = z("InputPlaceholder", null, e), {
    classNames: o,
    className: r,
    style: s,
    styles: i,
    unstyled: c,
    vars: a,
    __staticSelector: l,
    variant: f,
    error: p,
    mod: u,
    attributes: d,
    ...m
  } = n, g = K({
    name: ["InputPlaceholder", l],
    props: n,
    classes: re,
    className: r,
    style: s,
    classNames: o,
    styles: i,
    unstyled: c,
    attributes: d,
    rootSelector: "placeholder"
  });
  return /* @__PURE__ */ O.jsx(
    H,
    {
      ...g("placeholder"),
      mod: [{ error: !!p }, u],
      component: "span",
      variant: f,
      ref: t,
      ...m
    }
  );
});
en.classes = re;
en.displayName = "@mantine/core/InputPlaceholder";
function _i(e, { hasDescription: t, hasError: n }) {
  const o = e.findIndex((a) => a === "input"), r = e.slice(0, o), s = e.slice(o + 1), i = t && r.includes("description") || n && r.includes("error");
  return { offsetBottom: t && s.includes("description") || n && s.includes("error"), offsetTop: i };
}
const Li = {
  labelElement: "label",
  inputContainer: (e) => e,
  inputWrapperOrder: ["label", "description", "input", "error"]
}, $i = J((e, { size: t }) => ({
  label: {
    "--input-label-size": oe(t),
    "--input-asterisk-color": void 0
  },
  error: {
    "--input-error-size": t === void 0 ? void 0 : `calc(${oe(t)} - ${ee(2)})`
  },
  description: {
    "--input-description-size": t === void 0 ? void 0 : `calc(${oe(t)} - ${ee(2)})`
  }
})), tn = q((e, t) => {
  const n = z("InputWrapper", Li, e), {
    classNames: o,
    className: r,
    style: s,
    styles: i,
    unstyled: c,
    vars: a,
    size: l,
    variant: f,
    __staticSelector: p,
    inputContainer: u,
    inputWrapperOrder: d,
    label: m,
    error: g,
    description: h,
    labelProps: b,
    descriptionProps: w,
    errorProps: v,
    labelElement: R,
    children: S,
    withAsterisk: T,
    id: C,
    required: D,
    __stylesApiProps: _,
    mod: I,
    attributes: j,
    ...k
  } = n, F = K({
    name: ["InputWrapper", p],
    props: _ || n,
    classes: re,
    className: r,
    style: s,
    classNames: o,
    styles: i,
    unstyled: c,
    attributes: j,
    vars: a,
    varsResolver: $i
  }), E = {
    size: l,
    variant: f,
    __staticSelector: p
  }, N = eo(C), $ = typeof T == "boolean" ? T : D, P = v?.id || `${N}-error`, y = w?.id || `${N}-description`, A = N, L = !!g && typeof g != "boolean", V = !!h, M = `${L ? P : ""} ${V ? y : ""}`, B = M.trim().length > 0 ? M.trim() : void 0, Q = b?.id || `${N}-label`, W = m && /* @__PURE__ */ O.jsx(
    mt,
    {
      labelElement: R,
      id: Q,
      htmlFor: A,
      required: $,
      ...E,
      ...b,
      children: m
    },
    "label"
  ), G = V && /* @__PURE__ */ O.jsx(
    dt,
    {
      ...w,
      ...E,
      size: w?.size || E.size,
      id: w?.id || y,
      children: h
    },
    "description"
  ), te = /* @__PURE__ */ O.jsx(kn, { children: u(S) }, "input"), ge = L && /* @__PURE__ */ Ho(
    pt,
    {
      ...v,
      ...E,
      size: v?.size || E.size,
      key: "error",
      id: v?.id || P
    },
    g
  ), Ce = d.map((je) => {
    switch (je) {
      case "label":
        return W;
      case "input":
        return te;
      case "description":
        return G;
      case "error":
        return ge;
      default:
        return null;
    }
  });
  return /* @__PURE__ */ O.jsx(
    Ai,
    {
      value: {
        getStyles: F,
        describedBy: B,
        inputId: A,
        labelId: Q,
        ..._i(d, { hasDescription: V, hasError: L })
      },
      children: /* @__PURE__ */ O.jsx(
        H,
        {
          ref: t,
          variant: f,
          size: l,
          mod: [{ error: !!g }, I],
          ...F("root"),
          ...k,
          children: Ce
        }
      )
    }
  );
});
tn.classes = re;
tn.displayName = "@mantine/core/InputWrapper";
const Mi = {
  variant: "default",
  leftSectionPointerEvents: "none",
  rightSectionPointerEvents: "none",
  withAria: !0,
  withErrorStyles: !0,
  size: "sm"
}, Fi = J((e, t, n) => ({
  wrapper: {
    "--input-margin-top": n.offsetTop ? "calc(var(--mantine-spacing-xs) / 2)" : void 0,
    "--input-margin-bottom": n.offsetBottom ? "calc(var(--mantine-spacing-xs) / 2)" : void 0,
    "--input-height": ve(t.size, "input-height"),
    "--input-fz": oe(t.size),
    "--input-radius": t.radius === void 0 ? void 0 : Ae(t.radius),
    "--input-left-section-width": t.leftSectionWidth !== void 0 ? ee(t.leftSectionWidth) : void 0,
    "--input-right-section-width": t.rightSectionWidth !== void 0 ? ee(t.rightSectionWidth) : void 0,
    "--input-padding-y": t.multiline ? ve(t.size, "input-padding-y") : void 0,
    "--input-left-section-pointer-events": t.leftSectionPointerEvents,
    "--input-right-section-pointer-events": t.rightSectionPointerEvents
  }
})), Ee = ot((e, t) => {
  const n = z("Input", Mi, e), {
    classNames: o,
    className: r,
    style: s,
    styles: i,
    unstyled: c,
    required: a,
    __staticSelector: l,
    __stylesApiProps: f,
    size: p,
    wrapperProps: u,
    error: d,
    disabled: m,
    leftSection: g,
    leftSectionProps: h,
    leftSectionWidth: b,
    rightSection: w,
    rightSectionProps: v,
    rightSectionWidth: R,
    rightSectionPointerEvents: S,
    leftSectionPointerEvents: T,
    variant: C,
    vars: D,
    pointer: _,
    multiline: I,
    radius: j,
    id: k,
    withAria: F,
    withErrorStyles: E,
    mod: N,
    inputSize: $,
    attributes: P,
    __clearSection: y,
    __clearable: A,
    __defaultRightSection: L,
    ...V
  } = n, { styleProps: M, rest: B } = qo(V), Q = ft(), W = { offsetBottom: Q?.offsetBottom, offsetTop: Q?.offsetTop }, G = K({
    name: ["Input", l],
    props: f || n,
    classes: re,
    className: r,
    style: s,
    classNames: o,
    styles: i,
    unstyled: c,
    attributes: P,
    stylesCtx: W,
    rootSelector: "wrapper",
    vars: D,
    varsResolver: Fi
  }), te = F ? {
    required: a,
    disabled: m,
    "aria-invalid": !!d,
    "aria-describedby": Q?.describedBy,
    id: Q?.inputId || k
  } : {}, ge = Oi({
    __clearable: A,
    __clearSection: y,
    rightSection: w,
    __defaultRightSection: L,
    size: p
  });
  return /* @__PURE__ */ O.jsx(Si, { value: { size: p || "sm" }, children: /* @__PURE__ */ O.jsxs(
    H,
    {
      ...G("wrapper"),
      ...M,
      ...u,
      mod: [
        {
          error: !!d && E,
          pointer: _,
          disabled: m,
          multiline: I,
          "data-with-right-section": !!ge,
          "data-with-left-section": !!g
        },
        N
      ],
      variant: C,
      size: p,
      children: [
        g && /* @__PURE__ */ O.jsx(
          "div",
          {
            ...h,
            "data-position": "left",
            ...G("section", {
              className: h?.className,
              style: h?.style
            }),
            children: g
          }
        ),
        /* @__PURE__ */ O.jsx(
          H,
          {
            component: "input",
            ...B,
            ...te,
            ref: t,
            required: a,
            mod: { disabled: m, error: !!d && E },
            variant: C,
            __size: $,
            ...G("input")
          }
        ),
        ge && /* @__PURE__ */ O.jsx(
          "div",
          {
            ...v,
            "data-position": "right",
            ...G("section", {
              className: v?.className,
              style: v?.style
            }),
            children: ge
          }
        )
      ]
    }
  ) });
});
Ee.classes = re;
Ee.Wrapper = tn;
Ee.Label = mt;
Ee.Error = pt;
Ee.Description = dt;
Ee.Placeholder = en;
Ee.ClearButton = Oo;
Ee.displayName = "@mantine/core/Input";
function ki({ size: e, style: t, ...n }) {
  const o = e !== void 0 ? { width: ee(e), height: ee(e), ...t } : t;
  return /* @__PURE__ */ O.jsx(
    "svg",
    {
      viewBox: "0 0 10 7",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      style: o,
      "aria-hidden": !0,
      ...n,
      children: /* @__PURE__ */ O.jsx(
        "path",
        {
          d: "M4 4.586L1.707 2.293A1 1 0 1 0 .293 3.707l3 3a.997.997 0 0 0 1.414 0l5-5A1 1 0 1 0 8.293.293L4 4.586z",
          fill: "currentColor",
          fillRule: "evenodd",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function rc({ indeterminate: e, ...t }) {
  return e ? /* @__PURE__ */ O.jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 32 6",
      "aria-hidden": !0,
      ...t,
      children: /* @__PURE__ */ O.jsx("rect", { width: "32", height: "6", fill: "currentColor", rx: "3" })
    }
  ) : /* @__PURE__ */ O.jsx(ki, { ...t });
}
var ke = { root: "m_77c9d27d", inner: "m_80f1301b", label: "m_811560b9", section: "m_a74036a", loader: "m_a25b86ee", group: "m_80d6d844", groupSection: "m_70be2a01" };
const Fn = {
  orientation: "horizontal"
}, ji = J((e, { borderWidth: t }) => ({
  group: { "--button-border-width": ee(t) }
})), nn = q((e, t) => {
  const n = z("ButtonGroup", Fn, e), {
    className: o,
    style: r,
    classNames: s,
    styles: i,
    unstyled: c,
    orientation: a,
    vars: l,
    borderWidth: f,
    variant: p,
    mod: u,
    attributes: d,
    ...m
  } = z("ButtonGroup", Fn, e), g = K({
    name: "ButtonGroup",
    props: n,
    classes: ke,
    className: o,
    style: r,
    classNames: s,
    styles: i,
    unstyled: c,
    attributes: d,
    vars: l,
    varsResolver: ji,
    rootSelector: "group"
  });
  return /* @__PURE__ */ O.jsx(
    H,
    {
      ...g("group"),
      ref: t,
      variant: p,
      mod: [{ "data-orientation": a }, u],
      role: "group",
      ...m
    }
  );
});
nn.classes = ke;
nn.displayName = "@mantine/core/ButtonGroup";
const Bi = J(
  (e, { radius: t, color: n, gradient: o, variant: r, autoContrast: s, size: i }) => {
    const c = e.variantColorResolver({
      color: n || e.primaryColor,
      theme: e,
      gradient: o,
      variant: r || "filled",
      autoContrast: s
    });
    return {
      groupSection: {
        "--section-height": ve(i, "section-height"),
        "--section-padding-x": ve(i, "section-padding-x"),
        "--section-fz": i?.includes("compact") ? oe(i.replace("compact-", "")) : oe(i),
        "--section-radius": t === void 0 ? void 0 : Ae(t),
        "--section-bg": n || r ? c.background : void 0,
        "--section-color": c.color,
        "--section-bd": n || r ? c.border : void 0
      }
    };
  }
), on = q((e, t) => {
  const n = z("ButtonGroupSection", null, e), {
    className: o,
    style: r,
    classNames: s,
    styles: i,
    unstyled: c,
    vars: a,
    variant: l,
    gradient: f,
    radius: p,
    autoContrast: u,
    attributes: d,
    ...m
  } = n, g = K({
    name: "ButtonGroupSection",
    props: n,
    classes: ke,
    className: o,
    style: r,
    classNames: s,
    styles: i,
    unstyled: c,
    attributes: d,
    vars: a,
    varsResolver: Bi,
    rootSelector: "groupSection"
  });
  return /* @__PURE__ */ O.jsx(H, { ...g("groupSection"), ref: t, variant: l, ...m });
});
on.classes = ke;
on.displayName = "@mantine/core/ButtonGroupSection";
const Wi = {
  in: { opacity: 1, transform: `translate(-50%, calc(-50% + ${ee(1)}))` },
  out: { opacity: 0, transform: "translate(-50%, -200%)" },
  common: { transformOrigin: "center" },
  transitionProperty: "transform, opacity"
}, zi = J(
  (e, { radius: t, color: n, gradient: o, variant: r, size: s, justify: i, autoContrast: c }) => {
    const a = e.variantColorResolver({
      color: n || e.primaryColor,
      theme: e,
      gradient: o,
      variant: r || "filled",
      autoContrast: c
    });
    return {
      root: {
        "--button-justify": i,
        "--button-height": ve(s, "button-height"),
        "--button-padding-x": ve(s, "button-padding-x"),
        "--button-fz": s?.includes("compact") ? oe(s.replace("compact-", "")) : oe(s),
        "--button-radius": t === void 0 ? void 0 : Ae(t),
        "--button-bg": n || r ? a.background : void 0,
        "--button-hover": n || r ? a.hover : void 0,
        "--button-color": a.color,
        "--button-bd": n || r ? a.border : void 0,
        "--button-hover-color": n || r ? a.hoverColor : void 0
      }
    };
  }
), gt = ot((e, t) => {
  const n = z("Button", null, e), {
    style: o,
    vars: r,
    className: s,
    color: i,
    disabled: c,
    children: a,
    leftSection: l,
    rightSection: f,
    fullWidth: p,
    variant: u,
    radius: d,
    loading: m,
    loaderProps: g,
    gradient: h,
    classNames: b,
    styles: w,
    unstyled: v,
    "data-disabled": R,
    autoContrast: S,
    mod: T,
    attributes: C,
    ...D
  } = n, _ = K({
    name: "Button",
    props: n,
    classes: ke,
    className: s,
    style: o,
    classNames: b,
    styles: w,
    unstyled: v,
    attributes: C,
    vars: r,
    varsResolver: zi
  }), I = !!l, j = !!f;
  return /* @__PURE__ */ O.jsxs(
    Vn,
    {
      ref: t,
      ..._("root", { active: !c && !m && !R }),
      unstyled: v,
      variant: u,
      disabled: c || m,
      mod: [
        {
          disabled: c || R,
          loading: m,
          block: p,
          "with-left-section": I,
          "with-right-section": j
        },
        T
      ],
      ...D,
      children: [
        typeof m == "boolean" && /* @__PURE__ */ O.jsx(Ge, { mounted: m, transition: Wi, duration: 150, children: (k) => /* @__PURE__ */ O.jsx(H, { component: "span", ..._("loader", { style: k }), "aria-hidden": !0, children: /* @__PURE__ */ O.jsx(
          Kn,
          {
            color: "var(--button-color)",
            size: "calc(var(--button-height) / 1.8)",
            ...g
          }
        ) }) }),
        /* @__PURE__ */ O.jsxs("span", { ..._("inner"), children: [
          l && /* @__PURE__ */ O.jsx(H, { component: "span", ..._("section"), mod: { position: "left" }, children: l }),
          /* @__PURE__ */ O.jsx(H, { component: "span", mod: { loading: m }, ..._("label"), children: a }),
          f && /* @__PURE__ */ O.jsx(H, { component: "span", ..._("section"), mod: { position: "right" }, children: f })
        ] })
      ]
    }
  );
});
gt.classes = ke;
gt.displayName = "@mantine/core/Button";
gt.Group = nn;
gt.GroupSection = on;
export {
  ut as A,
  gt as B,
  ki as C,
  oc as D,
  ec as E,
  qt as F,
  To as G,
  js as H,
  Ee as I,
  Cn as J,
  Vs as K,
  Sn as L,
  ci as M,
  bo as N,
  Ut as O,
  lt as P,
  Ge as T,
  vr as a,
  no as b,
  qn as c,
  Ki as d,
  So as e,
  Jt as f,
  Ui as g,
  cr as h,
  or as i,
  to as j,
  ar as k,
  yr as l,
  ft as m,
  rr as n,
  qi as o,
  rc as p,
  oi as q,
  xe as r,
  Bs as s,
  Qi as t,
  eo as u,
  bn as v,
  Zi as w,
  nc as x,
  Ji as y,
  tc as z
};
